import React, { useState, useEffect, useRef } from 'react'
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  FormGroup,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Chip,
  IconButton,
  Tooltip,
  InputAdornment,
  OutlinedInput,
  ListItemText,
  CircularProgress,
  Menu,
  Popper,
  ClickAwayListener,
  Paper,
  useMediaQuery,
  FormLabel,
  Alert,
  Autocomplete,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import AddIcon from '@mui/icons-material/Add'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import DeleteIcon from '@mui/icons-material/Delete'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import serverData from '../../../../api/ServerData'
import {
  formatNumber,
  isEmpty,
  showToast,
  validateEmail,
  validateZipCode
} from '../../../../utils/AppHelper'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { logoutUser } from '../../../../actions/loginActions'
import { JobTypes, currencySymbol } from '../../../../utils/AppConstants'
import CustomModal from '../../../../commonComponents/CustomModal'
import JobPostPreviewModal from './JobPostPreviewModal'
import AppButton from '../../../../commonComponents/AppButton'
import TextEditor from '../../../../commonComponents/TextEditor'
import { TextBold, TextRegular } from '../../../../commonComponents/TextStyling'
import { BorderColor, CloudUpload } from '@mui/icons-material'
import * as pdfjsLib from 'pdfjs-dist/webpack';
import pdfToText from 'react-pdftotext'
import mammoth from 'mammoth';
import { Type } from '@google/genai'
import { handleFileUpload } from './handleFileUpload'
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

export default function PostNewJob({ user }) {
  var theme = useTheme()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [jobUpdateLoading, setJobUpdateLoading] = useState(false)
  const [jobPostLoading, setJobPostLoading] = useState(false)
  const [jobDraftLoading, setJobDraftLoading] = useState(false)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [openJDDialog, setOpenJDDialog] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [employer, setEmployer] = useState('');
  const [additionalDetails, setAdditionalDetails] = useState('');
  const [fileContent, setFileContent] = useState('');
  const [fileError, setFileError] = useState('');
  const location = useLocation()
  const data = location.state || {}

  useEffect(() => {
    if (data?.isEdit || data?.isAdd) {
      setJobTitle(data?.item?.jobTitle)
      setTotalPositions(data?.item?.totalPositions)
      setJobFunction(data?.item?.jobFunction)
      // setCountry(data?.item?.country)
      // setZipCode(data?.item?.zipCode.toString())
      setCity(data?.item?.city)
      // setState(data?.item?.state)
      setWorkLocationType(data?.item?.workLocationType)
      // setRelocationAssistance(data?.item?.relocationAssistance)
      // setJobRelocationAssistanceText(data?.item?.jobRelocationAssistanceText)
      // setWorkLocationInfo(data?.item?.workLocationInfo)
      setJobType(parseInt(data?.item?.jobType))
      // setContractDuration(data?.item?.contractDuration || '')
      // setDurationType(data?.item?.durationType)
      // setDesiredStartDate(
      //   data?.item?.desiredStartDate
      //     ? dayjs(data?.item?.desiredStartDate)
      //     : null
      // )
      // setSupplierLimit(data?.item?.supplierLimit || '')
      // setJobBenefits(data?.item?.jobBenefits)
      // setCity(data?.item?.city)
      // setEducationLevel(data?.item?.educationLevel)
      setExperienceLevel(data?.item?.experienceLevel)
      // setRequiredExpYear(data?.item?.requiredExpYear)
      // setRequiredExpMonth(data?.item?.requiredExpMonth)
      // setVisaSponsorship(data?.item?.visaSponsorship)
      setJobDescription(data?.item?.jobDescription)
      setSkillRequired(data?.item?.skillRequired.split(','))
      // setPreScreenQuesJobType(data?.item?.preScreenQuestions)

      // setJobCompensationAmountMin(data?.item?.jobCompensationAmountMin)
      // setJobCompensationAmountMax(data?.item?.jobCompensationAmountMax)
      // setJobCompensationText(data?.item?.jobCompensationText)
      // setRejectionPeriod(data?.item?.rejectionPeriod)
      // setRejectionReasons(
      //   data?.item?.rejectionReason.map(e => {
      //     e.isChecked = true
      //     return e
      //   })
      // )
      // setJobOrderNumber(data?.item?.jobOrderNumber)
      setEmailShow(!isEmpty(data?.item?.emailCc))
      setEmailCc(
        isEmpty(data?.item?.emailCc) ? [] : data?.item?.emailCc.split(',')
      )
      setJobDeadline(data?.item?.jobDeadline)
      setBudget(data?.item?.budget)
      setSalary(data?.item?.salary)
    }
  }, [])

  const [jobTitle, setJobTitle] = useState('')
  const [totalPositions, setTotalPositions] = useState(1)
  const [jobFunction, setJobFunction] = useState('')
  const [country, setCountry] = useState('')
  const [zipCode, setZipCode] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [workLocationType, setWorkLocationType] = useState('')
  const [workLocationInfo, setWorkLocationInfo] = useState('')
  const [relocationAssistance, setRelocationAssistance] = useState(0)
  const [jobRelocationAssistanceText, setJobRelocationAssistanceText] =
    useState('')
  const [jobType, setJobType] = useState('1')
  const [jobCompensationAmountMin, setJobCompensationAmountMin] = useState(0)
  const [jobCompensationAmountMax, setJobCompensationAmountMax] = useState(0)
  const [jobCompensationText, setJobCompensationText] = useState('')
  const [contractDuration, setContractDuration] = useState('')
  const [durationType, setDurationType] = useState('month')
  const [desiredStartDate, setDesiredStartDate] = useState(null)
  const [supplierLimit, setSupplierLimit] = useState('')
  const [jobBenefits, setJobBenefits] = useState('')
  const [rejectionPeriod, setRejectionPeriod] = useState('')

  //   For Sourcing only
  const [rejectionReasons, setRejectionReasons] = useState([])

  const [editRejection, setEditRejection] = useState('')
  const [viewRejection, setViewRejection] = useState(null)
  const [editRejectionModal, setEditRejectionModal] = useState({
    show: false,
    item: null
  })
  const [educationLevel, setEducationLevel] = useState('')
  const [experienceLevel, setExperienceLevel] = useState('')
  const [requiredExpYear, setRequiredExpYear] = useState(0)
  const [requiredExpMonth, setRequiredExpMonth] = useState(0)
  // const [visaSponsorship, setVisaSponsorship] = useState('no')
  const [jobDescription, setJobDescription] = useState('')
  const [skillRequired, setSkillRequired] = useState([])
  const [jobDeadline, setJobDeadline] = useState('')
  const [budget, setBudget] = useState('')
  const [salary, setSalary] = useState('')
  const [subEmployers, setSubEmployers] = useState([])

  const [emailShow, setEmailShow] = useState(false)
  const [inputEmail, setInputEmail] = useState('')
  const [subEmployersList, setSubEmployersList] = useState([])

  const [emailCc, setEmailCc] = useState([])
  const [jobOrderNumber, setJobOrderNumber] = useState('')

  const [preScreenQuesJobType, setPreScreenQuesJobType] = useState([])

  const [dropDownValues, setDorpDownValues] = useState({})
  const [modal, setModal] = useState({
    open: false,
    title: '',
    message: '',
    onClose: null
  })

  const [previewModal, setPreviewModal] = useState({
    open: false
  })

  const [zipCodeLoading, setZipCodeLoading] = useState(false)

  const [inputSkills, setInputSkills] = useState('')

  const [skillSuggestions, setSkillSuggestions] = useState([])
  const containerRef = useRef(null)
  const [openPopper, setOpenPopper] = useState(false)
  const [popperClick, setPopperClick] = useState(false)
  const [uploadedFile, setUploadedFile] = useState(null);
  const [initialStep, setInitialStep] = useState(true);
  const [extractedJDText, setExtractedJDText] = React.useState('');

  const [extractedJobData, setExtractedJobData] = useState(null);
  const [result, setResult] = useState(null);
  const [isSubmittingFromPDF, setIsSubmittingFromPDF] = useState(false);
  const getSkillSuggestions = skill_name => {
    serverData.getSkillSuggestions(
      { skill_name },
      result => {
        if (result.status) {
          setSkillSuggestions(result.response)
          if (result.response.length > 0) {
            setOpenPopper(true)
          }
        }
      },
      error => {
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  useEffect(() => {
    // if (!user.isProfileCompleted) {
    //   setModal({
    //     open: true,
    //     title: 'Profile incomplete',
    //     message: `Please update your profile to start posting jobs. ${
    //       user.isSubEmployer ? '\nAsk your account manager to do so.' : ''
    //     }`,
    //     disableOverlay: true,
    //     onClose: () => {
    //       if (user.isSubEmployer) {
    //         navigate('/employer/dashboard')
    //       } else {
    //         navigate('/employer/editprofile')
    //       }
    //     }
    //   })
    // }
    if (!data?.isEdit) {
      // serverData.getPreQuestions(
      //   { jobTypeId: jobType },
      //   result => {
      //     if (result.status) {
      //       setPreScreenQuesJobType(result.response)
      //     }
      //   },
      //   error => {
      //     if (error.status === 401) {
      //       dispatch(logoutUser(navigate)) // eslint-disable-next-line
      //     }
      //   }
      // )
      // if (jobType === JobTypes.Sourcing) {
      //   serverData.getRejectedReasons(
      //     {},
      //     result => {
      //       if (result.status) {
      //         setRejectionReasons(result.response)
      //       }
      //     },
      //     error => {
      //       if (error.status === 401) {
      //         dispatch(logoutUser(navigate)) // eslint-disable-next-line
      //       }
      //     }
      //   )
      // } else {
      // }
    }
  }, [jobType])

  const handleEnterSkills = (event, skill) => {
    if (event.key === 'Enter' || event.type === 'click') {
      var error = {}
      var trimmedSkills = ''
      if (event.type === 'click') {
        trimmedSkills = skill
      } else {
        trimmedSkills = inputSkills.trim()
      }

      if (trimmedSkills && !skillRequired.includes(trimmedSkills)) {
        setSkillRequired([...skillRequired, trimmedSkills])
        setInputSkills('')
      } else {
        showToast('Skill is already added.')
        setFormError(error)
      }
    }
  }
  const handleDeleteSkill = index => {
    setSkillRequired(skillRequired.filter((_, i) => i !== index))
  }

  useEffect(function () {
    serverData.getJobPostDropDownValues(
      {},
      result => {
        if (result.status) {
          setDorpDownValues(result.response)
        }
      },
      error => {
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
    getSubEmployers()
  }, [])

  function getSubEmployers() {
    serverData.getSubEmployers(
      {},
      result => {
        if (result.status) {
          let { response } = result
          setSubEmployersList(response)
          let subEmp = []
          if (data?.isEdit) {
            var arr = data.item.subEmployers.split(',')
            subEmp = response.filter(e => arr.includes(e.id.toString()))
          }

          if (user.isSubEmployer) {
            var subUser = response.find(e => e.email === user.email)
            if (subUser) {
              var i = subEmp.indexOf(subUser)
              if (i === -1) {
                subUser.disabled = true
                subEmp.push(subUser)
              } else {
                subEmp[i].disabled = true
              }
            }
          }

          setSubEmployers(subEmp)
        }
      },
      error => {
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  const closeEditModal = () => {
    setEditRejectionModal({ show: false, item: null })
    setEditRejection('')
  }

  function getStateAndCityByZipcode() {
    setZipCodeLoading(true)
    serverData.getStateAndCityByZipcode(
      { zipCode },
      result => {
        if (result.status) {
          let { city, state } = result.response
          setState(state)
          setCity(city)
        }
        setZipCodeLoading(false)
      },
      error => {
        setZipCodeLoading(false)

        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  const [formError, setFormError] = useState({})
  const validateForm = () => {
    const error = {}

    if (isEmpty(jobTitle)) {
      error.jobTitle = 'Please enter job title.'
    }
    if (isEmpty(totalPositions)) {
      error.totalPositions = 'Please select number of position'
    }
    if (isEmpty(jobFunction)) {
      error.jobFunction = 'Please select job function'
    }
    // if (isEmpty(country)) {
    //   error.country = 'Please select the country'
    // }
    // if (isEmpty(zipCode)) {
    //   error.zipCode = 'Please enter Zip code'
    // } else if (!validateZipCode(zipCode)) {
    //   error.zipCode = 'Zip code should be min 4 and max 11 digits.'
    // }

    // if (isEmpty(state)) {
    //   error.state = 'Please enter state'
    // }

    if (isEmpty(city)) {
      error.city = 'Please enter city'
    }

    if (isEmpty(workLocationType)) {
      error.workLocationType = 'Please select work location type'
    }

    // if (isEmpty(relocationAssistance) || relocationAssistance === 0) {
    //   error.relocationAssistance = 'Please select relocation assistance'
    // }

    if (isEmpty(jobType)) {
      error.jobType = 'Please select job type'
    }

    // if (jobType === JobTypes.Contract) {
    //   if (isEmpty(contractDuration)) {
    //     error.contractDuration = 'Please enter contract duration'
    //   }
    //   // }
    //   if (isEmpty(desiredStartDate)) {
    //     error.desiredStartDate = 'Please select desired start date'
    //   }
    //   if (isEmpty(supplierLimit)) {
    //     error.supplierLimit = 'Please enter candidate submission limit'
    //   }
    // }

    // if (jobType === JobTypes.Sourcing) {
    //   for (let index = 0; index < rejectionReasons.length; index++) {
    //     const element = rejectionReasons[index]
    //     if (element.isUserDefined && isEmpty(element.reason)) {
    //       if (!error.hasOwnProperty('rejectionReasons')) {
    //         error.rejectionReasons = {}
    //       }
    //       error.rejectionReasons[index] = {
    //         reason: 'Please enter rejection reason'
    //       }
    //     }
    //   }
    // }

    // if (jobCompensationAmountMin !== 0 || jobCompensationAmountMax !== 0) {
    //   if (jobCompensationAmountMin === 0) {
    //     error.jobCompensation = 'Please select first field'
    //   }

    //   if (jobCompensationAmountMax <= jobCompensationAmountMin) {
    //     error.jobCompensation =
    //       'Please ensure that the compensation value in the first field is less than the value in the second field'
    //   }
    // }

    // if (isEmpty(educationLevel)) {
    //   error.educationLevel = 'Please select education level'
    // }
    if (isEmpty(experienceLevel)) {
      error.experienceLevel = 'Please select job-experience level'
    }
    if (isEmpty(jobDescription)) {
      error.jobDescription = 'Please enter job description.'
    }
    if (skillRequired.length === 0) {
      error.skillRequired = 'Press enter to add skills.'
    }

    // if (preScreenQuesJobType.length > 0) {
    //   for (let index = 0; index < preScreenQuesJobType.length; index++) {
    //     const element = preScreenQuesJobType[index]
    //     if (isEmpty(element.question)) {
    //       if (!error.hasOwnProperty('preScreenQuesJobType')) {
    //         error.preScreenQuesJobType = {}
    //       }
    //       error.preScreenQuesJobType[index] = {
    //         question: 'Please enter a question'
    //       }
    //     }
    //     if (element.type !== 'textfield') {
    //       for (
    //         let optionIndex = 0;
    //         optionIndex < element.options.length;
    //         optionIndex++
    //       ) {
    //         const option = element.options[optionIndex]
    //         if (isEmpty(option.name)) {
    //           if (!error.hasOwnProperty('preScreenQuesJobType')) {
    //             error.preScreenQuesJobType = {}
    //           }
    //           if (!error.preScreenQuesJobType.hasOwnProperty(index)) {
    //             error.preScreenQuesJobType[index] = {}
    //           }
    //           if (
    //             !error.preScreenQuesJobType[index].hasOwnProperty('options')
    //           ) {
    //             error.preScreenQuesJobType[index]['options'] = {}
    //           }
    //           error.preScreenQuesJobType[index]['options'][optionIndex] =
    //             'Please enter a option'
    //         }
    //       }
    //     }
    //   }
    // }

    // if (emailShow && emailCc.length === 0) {
    //   error.emailCc = 'Press enter to add email.'
    // }

    // if (subEmployers.length === 0) {
    //   error.subEmployers = "Please select sub-employer's name."
    // }
    setFormError(error)
    return Object.keys(error).length === 0
  }
  const handleSubmitJob = async isDraft => {
    if (validateForm()) {
      if (isDraft) {
        setJobDraftLoading(true)
      } else if (data?.isEdit) {
        setJobUpdateLoading(true)
      } else {
        setJobPostLoading(true)
      }
      var body = {
        jobTitle,
        totalPositions,
        jobFunction,
        // country,
        // zipCode,
        city,
        // state,
        workLocationType,
        // workLocationInfo,
        // relocationAssistance,
        // jobRelocationAssistanceText,
        jobType,
        // jobCompensationAmountMin,
        // jobCompensationAmountMax,
        // jobCompensationText,
        // contractDuration,
        // durationType,
        // desiredStartDate: desiredStartDate
        //   ? dayjs(desiredStartDate).format('YYYY-MM-DD hh:mm:ss')
        //   : '',
        // supplierLimit,
        // jobBenefits,
        // rejectionPeriod,
        // rejectionReasons: rejectionReasons.filter(e => e.isChecked),
        // educationLevel,
        experienceLevel,
        // requiredExpYear,
        // requiredExpMonth,
        budget,
        salary,
        jobDeadline,
        // visaSponsorship,
        jobDescription,
        skillRequired,
        // preScreenQuesJobType,
        subEmployers: subEmployers?.map(e => e.id)
        // emailCc
        // jobOrderNumber
      }
      if (data?.isEdit) {
        body.jobId = data?.item?.jobId
        await serverData.editPostedJob(
          body,
          data => {
            if (data.status) {
              setModal({
                open: true,
                title: 'Congratulations',
                message: data.message,
                onClose: () => {
                  navigate('/employer/managejob')
                }
              })
            } else {
              showToast(data.message)
            }
            setJobUpdateLoading(false)
          },
          error => {
            showToast(error.statusText)
            setJobUpdateLoading(false)
          }
        )
      } else {
        if (isDraft) {
          body.status = 'draft'
        }
        // console.log('***6***', body)
        await serverData.postJob(
          body,

          data => {
            debugger
            if (data.status) {
              setModal({
                open: true,
                title: 'Congratulations',
                message: data.message,
                onClose: () => {
                  navigate('/employer/managejob')
                }
              })
            } else {
              showToast(data.message)
            }
            setJobDraftLoading(false)
            setJobPostLoading(false)
          },
          error => {
            showToast(error.statusText)
            setJobDraftLoading(false)
            setJobPostLoading(false)
          }
        )
      }
    }
  }


  function deleteQuestionFromLibrary(item, index) {
    serverData.deleteQuestionFromLibrary(
      { id: item.id },
      data => {
        if (data.status) {
          const questions = [...preScreenQuesJobType]
          questions.splice(index, 1)
          setPreScreenQuesJobType(questions)
        } else {
          showToast(data.message)
        }
      },
      error => { }
    )
  }

  function fromCompensationValues() {
    const resultArray = [
      { value: 25000 },
      { value: 50000 },
      { value: 75000 },
      { value: 100000 },
      { value: 125000 },
      { value: 150000 },
      { value: 175000 },
      { value: 200000 },
      { value: 225000 },
      { value: 250000 },
      { value: 275000 },
      { value: 500000 },
      { value: 750000 },
      { value: 1000000 },
      { value: 1500000 },
      { value: 2000000 },
      { value: 2500000 },
      { value: 5000000 },
      { value: 10000000 },
      { value: 15000000 },
      { value: 20000000 },
      { value: 25000000 },
      { value: 30000000 }
    ]

    return resultArray
  }

  function toCompensationValue() {
    let startValue = jobCompensationAmountMin

    let resultArray = []
    for (let i = 0; i < 20; i++) {
      startValue += 25000
      resultArray.push({ value: startValue })
    }

    return resultArray
  }
  const [step, setStep] = useState(() => {
    if (data?.case) return data.case
    if (data?.isEdit || data?.isAdd) return 2
    return 1
  })
  const totalSteps = 6

  const mainSection = {
    display: 'flex',
    // flexDirection: 'row',
    justifyContent: 'space-between'
    // flexWrap: 'wrap',
  }

  const leftSide = {
    marginBottom: '24px'
  }

  const rightSide = {
    // flex: '1 1 45%'
  }

  // const input = {
  //   width: '100%',
  //   padding: '12px',
  //   border: '1px solid #ccc',
  //   borderRadius: '6px',
  //   marginBottom: '24px'
  // };

  const exampleList = {
    paddingLeft: '20px',
    color: '#555',
    fontSize: '14px',
    lineHeight: '1.6'
  }

  const progressBarContainer = {
    height: '4px',
    width: '100%',
    backgroundColor: '#DDDDDD',
    // borderRadius: '8px',
    marginTop: '32px',
    marginBottom: '32px'
  }

  const progressBarFill = {
    height: '100%',
    width: `${(step / totalSteps) * 100}%`,
    backgroundColor: '#000',
    borderRadius: '8px',
    transition: 'width 0.3s ease'
  }
  const jobRoles = [
    'Software Engineer',
    'Frontend Developer',
    'Backend Developer',
    'Full Stack Developer',
    'Data Scientist',
    'Product Manager',
    'UI/UX Designer',
    'DevOps Engineer',
    'Quality Assurance Engineer',
    'Business Analyst',
    'Project Manager',
    'Marketing Manager',
    'Sales Representative',
    'Human Resources Manager',
    'Financial Analyst',
    'Content Writer',
    'Digital Marketing Specialist',
    'System Administrator',
    'Database Administrator',
    'Mobile App Developer',
    'Cloud Architect',
    'Cybersecurity Specialist',
    'Machine Learning Engineer',
    'Technical Writer',
    'React js',
    'Node js'
  ];

  const apiKey = process.env.REACT_APP_GROQ_API_KEY;
  // const groq = new Groq({ 
  //   apiKey: apiKey,
  //   dangerouslyAllowBrowser: true 
  // });

  const generateDescription = async () => {
    if (!jobTitle.trim()) {
      setError("Job title is required to generate description.");
      return;
    }

    setLoading(true);
    setError('');

    const experienceLevelName = dropDownValues?.experienceLevel?.find(
      item => item.id === experienceLevel
    )?.name || experienceLevel;

    const getDropdownLabel = (arr, id) => {
      if (!Array.isArray(arr) || id == null) return id;
      const found = arr.find(item => String(item.id) === String(id));
      return found ? found.name : id;
    };

    const jobTypeName = getDropdownLabel(dropDownValues?.jobTypes, jobType);
    const workLocationTypeName = dropDownValues?.workLocationTypes?.find(
      item => item.id === workLocationType
    )?.name || workLocationType;

    const jobFunctionName = dropDownValues?.jobFunctions?.find(
      item => item.id === jobFunction
    )?.name || jobFunction;


    const prompt = `
Generate a clear, professional job description for the role of "${jobTitle}"${employer ? ` at "${employer}"` : ''}.
${city ? `Location: ${city}` : ''}${workLocationTypeName ? ` (${workLocationTypeName})` : ''}.
${jobTypeName ? `Job Type: ${jobTypeName}.` : ''}
${experienceLevelName ? `Experience required: ${experienceLevelName}.` : ''}
${skillRequired ? `Required skills: ${skillRequired}.` : ''}
${jobFunctionName ? `Job Function: ${jobFunctionName}.` : ''}
${totalPositions ? `Number of positions available: ${totalPositions}.` : ''}
${additionalDetails ? `Additional Details: ${additionalDetails}.` : ''}

IMPORTANT FORMATTING REQUIREMENTS:
- Use ONLY plain text without any special formatting characters
- Do NOT use asterisks (*), hash symbols (#), underscores (_), or double asterisks (**)
- Do NOT use bullet points with special characters
- Use simple dashes (-) or numbers (1, 2, 3) for lists if needed
- Use capital letters for section headings like JOB TITLE, RESPONSIBILITIES, etc.
- Use proper line breaks and spacing for readability
- Format as clean, professional business text that can be directly copied and pasted

Only return the actual job description without any notes, instructions, or templates.
`;
    try {
      const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${apiKey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          model: 'llama-3.1-8b-instant',
          messages: [
            {
              role: 'user',
              content: prompt
            }
          ],
          temperature: 0.7,
          max_tokens: 2000,
          stream: false
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data?.choices?.[0]?.message?.content) {
        let generatedText = data.choices[0].message.content;


        generatedText = generatedText.replace(/<[^>]*>/g, '');

        let jobDetailsSection = '<div style="background-color: #f8f9fa; padding: 20px; border-radius: 8px; margin-bottom: 25px; border-left: 4px solid #007bff;">';
        jobDetailsSection += '<div style="font-weight: bold; font-size: 18px; color: #2c3e50; margin-bottom: 15px; text-align: center; text-transform: uppercase;">JOB DETAILS</div>';

        if (jobTitle) {
          jobDetailsSection += `<div style="margin-bottom: 8px;"><strong style="color: #495057;">Job Title</strong> - ${jobTitle}</div>`;
        }
        if (jobTypeName) {
          jobDetailsSection += `<div style="margin-bottom: 8px;"><strong style="color: #495057;">Job Type</strong> - ${jobTypeName}</div>`;
        }
        if (city) {
          jobDetailsSection += `<div style="margin-bottom: 8px;"><strong style="color: #495057;">City</strong> - ${city}</div>`;
        }
        if (workLocationTypeName) {
          jobDetailsSection += `<div style="margin-bottom: 8px;"><strong style="color: #495057;">Work Location</strong> - ${workLocationTypeName}</div>`;
        }
        if (experienceLevelName) {
          jobDetailsSection += `<div style="margin-bottom: 8px;"><strong style="color: #495057;">Experience Level</strong> - ${experienceLevelName}</div>`;
        }
        if (jobFunctionName) {
          jobDetailsSection += `<div style="margin-bottom: 8px;"><strong style="color: #495057;">Job Function</strong> - ${jobFunctionName}</div>`;
        }
        if (employer) {
          jobDetailsSection += `<div style="margin-bottom: 8px;"><strong style="color: #495057;">Company</strong> - ${employer}</div>`;
        }
        if (totalPositions) {
          jobDetailsSection += `<div style="margin-bottom: 8px;"><strong style="color: #495057;">Positions Available</strong> - ${totalPositions}</div>`;
        }
        if (skillRequired) {
          jobDetailsSection += `<div style="margin-bottom: 8px;"><strong style="color: #495057;">Required Skills</strong> - ${skillRequired}</div>`;
        }
        if (additionalDetails) {
          jobDetailsSection += `<div style="margin-bottom: 8px;"><strong style="color: #495057;">Additional Details</strong> - ${additionalDetails}</div>`;
        }

        jobDetailsSection += '</div>';


        generatedText = generatedText
          .replace(/^JOB TITLE[\s\S]*?(?=KEY RESPONSIBILITIES|RESPONSIBILITIES|$)/gim, '')
          .replace(/^LOCATION[\s\S]*?(?=KEY RESPONSIBILITIES|RESPONSIBILITIES|$)/gim, '')
          .replace(/^JOB TYPE[\s\S]*?(?=KEY RESPONSIBILITIES|RESPONSIBILITIES|$)/gim, '')
          .replace(/^COMPANY OVERVIEW[\s\S]*?(?=KEY RESPONSIBILITIES|RESPONSIBILITIES|$)/gim, '')
          .replace(/^JOB SUMMARY[\s\S]*?(?=KEY RESPONSIBILITIES|RESPONSIBILITIES|$)/gim, '')
          .replace(/^JOB FUNCTION[\s\S]*?(?=KEY RESPONSIBILITIES|RESPONSIBILITIES|$)/gim, '')
          .replace(/^SUMMARY[\s\S]*?(?=KEY RESPONSIBILITIES|RESPONSIBILITIES|$)/gim, '')
          .replace(/^DEPARTMENT:?\s*.*?(?=\n|$)/gim, '')
          .replace(/^POSITION SUMMARY[\s\S]*?(?=KEY RESPONSIBILITIES|RESPONSIBILITIES|$)/gim, '')
          .replace(/^We are (seeking|a leading|looking for)[\s\S]*?(?=KEY RESPONSIBILITIES|RESPONSIBILITIES|$)/gim, '');


        generatedText = generatedText
          .replace(/^\s*\n+/gm, '')
          .replace(/\n\s*\n\s*\n+/g, '\n\n')
          .replace(/\n{3,}/g, '\n\n')
          .trim();


        generatedText = generatedText
          .replace(/^(EXPERIENCE|JOB SUMMARY|RESPONSIBILITIES|REQUIRED SKILLS|QUALIFICATIONS|JOB DESCRIPTION|ABOUT THE ROLE):\s*/gim,
            '<div style="font-weight: bold; font-size: 16px; color: #2c3e50; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; border-bottom: 2px solid #dee2e6; padding-bottom: 5px;">$1</div>')
          .replace(/^(Key Responsibilities|KEY RESPONSIBILITIES|Required Skills and Qualifications|Job Summary|):\s*/gim,
            '<div style="font-weight: bold; font-size: 15px; color: #34495e; margin-top: 18px; margin-bottom: 8px;">$1</div>')
          .replace(/^\s*[-•]\s+(.+)$/gm, '<div style="margin-left: 20px; margin-bottom: 6px; padding-left: 10px; border-left: 2px solid #dee2e6; line-height: 1.5;">• $1</div>')
          .replace(/^\s*(\d+)\.\s+(.+)$/gm, '<div style="margin-left: 20px; margin-bottom: 6px; padding-left: 10px; line-height: 1.5; font-weight: 500;">$1. $2</div>')
          .replace(/\n\n/g, '<div style="margin-bottom: 15px;"></div>')
          .replace(/\n/g, '<br/>');

        const finalContent = `
        <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.6; color: #333; max-width: 900px; margin: 0 auto; padding: 20px;">
            ${jobDetailsSection}
            <div style="background-color: #ffffff; padding: 20px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                ${generatedText}
            </div>
        </div>
      `;

        setJobDescription(finalContent);
      } else {
        setError("Failed to generate a response. Please try again.");

      }
    } catch (err) {
      // console.error("Groq API error:", err);
      setError("Failed to generate job description. Please check your API key and try again.");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setJobTitle('');
    setJobType('');
    setCity('');
    setWorkLocationType('');
    setSkillRequired('');
    setExperienceLevel('');
    setJobFunction('');
    setTotalPositions('');
    setEmployer('');
    setAdditionalDetails('');
    setJobDescription('');
    setError('');
    setFormError({});
    setLoading(false);
  };

  const handleSubmit = async () => {
    if (!uploadedFile) {
      setError('Please select a file first');
      return;
    }

    const formData = new FormData();
    formData.append('file', uploadedFile);


  };

  const handleClose = () => {
    setOpenJDDialog(false);
    resetForm();
  };

  const htmlToPlainText = (html) => {

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;


    let plainText = tempDiv.textContent || tempDiv.innerText || '';


    plainText = plainText
      .replace(/\n\s*\n\s*\n/g, '\n\n')
      .replace(/^\s+|\s+$/g, '')
      .replace(/[ \t]+/g, ' ')
      .replace(/\s*•\s*/g, '\n• ')
      .replace(/\s*\n\s*/g, '\n');

    return plainText;
  };




  // Function to read file content based on file type
  const readTextFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        resolve(event.target.result || 'File appears to be empty');
      };

      reader.onerror = () => {
        reject(new Error('Failed to read text file'));
      };

      reader.readAsText(file);
    });
  };

  // Function to load PDF.js library dynamically
  const loadPDFJS = () => {
    return new Promise((resolve, reject) => {
      if (window.pdfjsLib) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
      script.onload = () => {
        // Configure PDF.js worker
        window.pdfjsLib.GlobalWorkerOptions.workerSrc =
          'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
        resolve();
      };
      script.onerror = () => reject(new Error('Failed to load PDF.js'));
      document.head.appendChild(script);
    });
  };

  // Function to parse PDF content using PDF.js with progress tracking
  const parsePDFContent = async (arrayBuffer) => {
    try {
      // Load PDF.js library dynamically if not already loaded
      if (!window.pdfjsLib) {
        await loadPDFJS();
      }

      const pdf = await window.pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      let fullText = '';

      // Limit pages for performance (optional)
      const maxPages = Math.min(pdf.numPages, 50); // Process max 50 pages

      // Extract text from each page with progress tracking
      for (let pageNum = 1; pageNum <= maxPages; pageNum++) {
        try {
          const page = await pdf.getPage(pageNum);
          const textContent = await page.getTextContent();

          const pageText = textContent.items
            .map(item => item.str)
            .join(' ')
            .trim();

          if (pageText) {
            fullText += `--- Page ${pageNum} ---\n${pageText}\n\n`;
          }

          // Optional: Add delay for very large PDFs to prevent UI blocking
          if (pageNum % 10 === 0 && pdf.numPages > 20) {
            await new Promise(resolve => setTimeout(resolve, 10));
          }
        } catch (pageError) {
          // console.warn(`Error processing page ${pageNum}:`, pageError);
          fullText += `--- Page ${pageNum} ---\n[Error reading page content]\n\n`;
        }
      }

      if (pdf.numPages > maxPages) {
        fullText += `\n--- Note: Only first ${maxPages} pages shown (total: ${pdf.numPages} pages) ---`;
      }

      return fullText || 'No text content found in PDF';
    } catch (error) {
      // console.error('Error parsing PDF:', error);
      throw new Error(`Failed to parse PDF content: ${error.message}`);
    }
  };


  const readFileContent = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async (event) => {
        try {

          if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {

            try {
              const pdfContent = await parsePDFContent(event.target.result);
              resolve(pdfContent);
            } catch (pdfError) {
              // console.error('PDF parsing failed:', pdfError);
              resolve('PDF content could not be extracted. Please try converting to text format.');
            }
          } else if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
            file.type === 'application/msword' ||
            file.name.toLowerCase().endsWith('.doc') ||
            file.name.toLowerCase().endsWith('.docx')) {

            try {
              const wordContent = await parseWordContent(event.target.result);
              resolve(wordContent);
            } catch (wordError) {
              // console.error('Word document parsing failed:', wordError);
              resolve('Word document content could not be extracted. Please try converting to text format.');
            }
          } else if (file.type === 'text/plain' ||
            file.name.toLowerCase().endsWith('.txt') ||
            file.type === '' ||
            !file.type) {

            resolve(event.target.result || 'File appears to be empty');
          } else {

            resolve(event.target.result || 'No readable content found');
          }
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (error) => {
        reject(new Error('Failed to read file: ' + (error.message || 'Unknown error')));
      };

      reader.onabort = () => {
        reject(new Error('File reading was aborted'));
      };


      const timeout = setTimeout(() => {
        reader.abort();
        reject(new Error('File reading timeout'));
      }, 15000);

      reader.onloadend = () => {
        clearTimeout(timeout);
      };

      try {

        if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {
          reader.readAsArrayBuffer(file);
        } else if (file.name.toLowerCase().endsWith('.docx') || file.name.toLowerCase().endsWith('.doc')) {
          reader.readAsArrayBuffer(file);
        } else {
          reader.readAsText(file);
        }
      } catch (error) {
        clearTimeout(timeout);
        reject(error);
      }
    });
  };


  const parseWordContent = async (arrayBuffer) => {
    try {
      // console.log('Word document parsing not implemented - requires mammoth.js library');
      throw new Error('Word document parsing requires mammoth.js library');
    } catch (error) {
      throw new Error('Word document parsing failed: ' + error.message);
    }
  };


  const extractJobData = (text, fileName) => {
    // console.log(' Starting comprehensive job data extraction...');

    if (!text || typeof text !== 'string') {
      // console.log(' Invalid text input');
      return null;
    }


    const normalizedText = text
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n')
      .replace(/\s+/g, ' ')
      .trim();

    // console.log(' Text sample:', normalizedText.substring(0, 300) + '...');

    const jobData = {
      JobTitle: null,
      totalPositions: totalPositions !== '' ? parseInt(totalPositions, 10) : null,
      jobFunction: null,
      city: null,
      workLocationType: null,
      jobType: null,
      experienceLevel: null,
      budget: null,
      salary: null,
      jobDeadline: null,
      jobDescription: null,
      skillRequired: [],
      additionalDetails: null
    };


    const extractAndClean = (patterns, fieldName, cleaningFunction = null) => {
      for (const pattern of patterns) {
        const match = normalizedText.match(pattern);
        if (match && match[1]) {
          let value = match[1].trim();
          if (cleaningFunction) {
            value = cleaningFunction(value);
          } else {
            value = value.replace(/[,\.].*$/g, '').trim();
          }
          if (value.length > 0) {
            // console.log(`${fieldName} found:`, value);
            return value;
          }
        }
      }
      return null;
    };

    jobData.JobTitle = extractAndClean([
      /(?:Job Title|Position|Role|Title)\s*[-:–—]\s*(.+?)(?:\s*job\s*type|\n|$)/i,
      /(?:Position Applied|Job Position|Current Role)\s*[-:–—]?\s*(.+?)(?:\n|$)/i,
    ], 'Job Title', (value) => {
      return value
        .replace(/job\s*type.*$/i, '')
        .replace(/[,\.\-\n\r].*$/, '')
        .replace(/^\W+|\W+$/g, '')
        .trim();
    });


    jobData.jobType = extractAndClean([
      /(?:Job Type|Employment Type|Contract Type)[\s:]*(.+?)(?:\n|experience|salary|$)/i,
      /(Contract\s*[-–—]?\s*\d+\s*Months?)/i,
      /(Full[\s\-]?time|Part[\s\-]?time|Contract|Freelance|Internship)/i
    ], 'Job Type', (value) => {

      value = value.replace(/[\n\r].*$/, '').trim();
      const contractMatch = value.match(/(Contract)\s*[-–—]?\s*(\d+)\s*(Months?)/i);
      if (contractMatch) {
        return `${contractMatch[1]} - ${contractMatch[2]} ${contractMatch[3]}`;
      }

      return value;
    });


    jobData.experienceLevel = extractAndClean([
      /(?:Experience Level|Experience Required)[\s:]*(.+?)(?:\n|salary|job|$)/i,
      /(Senior[\s\-]*level\s*\([^)]+\))/i,
      /(Junior[\s\-]*level\s*\([^)]+\))/i,
      /(Mid[\s\-]*level\s*\([^)]+\))/i,
      /(Entry[\s\-]*level\s*\([^)]+\))/i,
      /(\d+[\-–—]\d+\s*years?\s*(?:of\s*)?experience)/i
    ], 'Experience Level', (value) => {
      // Keep the format like "Senior-level (6-10 years)"
      value = value.replace(/[\n\r].*$/, '').trim();
      return value;
    });

    // City extraction with cleaning
    jobData.city = extractAndClean([
      /(?:City|Location|Work Location)[\s:]*-?\s*([^\n\-•–—:]{1,100}?)(?=\s*(?:Work Location|Experience Level|Job Type|Job Function|Positions Available|Skills|Budget|RESPONSIBILITIES|$))/i
    ], 'City', (value) => {
      return value
        .replace(/[,\.].*$/, '')
        .replace(/\s+/g, ' ')
        .replace(/[^a-zA-Z\s]/g, '')
        .trim()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    });


    jobData.workLocationType = extractAndClean([
      /(?:Work Type|Location Type|Work Arrangement|Work Mode|Work Location)[\s:]*([\w\s-]+?)(?=\s*(?:Experience Level|Job Type|Salary|$))/i
    ], 'Work Location Type') || detectWorkLocationType(normalizedText);

    // console.log(' Extracted workLocationType:', jobData.workLocationType);

    jobData.jobFunction = extractAndClean([
      /(?:Job Function|Department|Function|Field|Education)[\s:]*([\s\S]{1,200}?)(?=(?:Positions Available|Required Skills|Technical Skills|Skills Required|Additional Details|Experience Required|RESPONSIBILITIES|SKILLS AND QUALIFICATIONS|WORKING ARRANGEMENT|EDUCATION|$))/i
    ], 'Job Function', (value) => {

      return value
        .replace(/^[\-•\s]*/g, '')
        .replace(/\s+/g, ' ')
        .replace(/[^a-zA-Z\s\-\/]/g, '')
        .split(' ')
        .slice(0, 6)
        .join(' ')
        .trim();
    });



    const positionsMatch = normalizedText.match(/(?:Positions Available|Total Positions|Openings)[\s:]*(\d+)/i);
    if (positionsMatch) {
      jobData.totalPositions = parseInt(positionsMatch[1]);
      // console.log(' Positions Available:', jobData.totalPositions);
    }

    // Fixed extractSkills function to handle "Required Skills - skill1,skill2,skill3" format
    const extractSkills = (text) => {
      // console.log(' Extracting skills...');

      const match = text.match(/Required Skills\s*[-–—]\s*(.+?)(?=\s*(?:Experience|Salary|Job Deadline|Responsibilities|Education|Budget|Working Arrangement|Work Location|City|$))/is);

      if (!match || !match[1]) {
        // console.warn(' No skills matched in the expected format');
        return [];
      }

      const rawSkills = match[1].trim();
      // console.log(' Raw skills string:', rawSkills);

      const skillItems = rawSkills
        .split(/[,;]/) // comma or semicolon
        .map(s => s.trim())
        .filter(s =>
          s.length > 1 &&
          !/^(skills?|technical|required)$/i.test(s)
        );

      const uniqueSkills = [...new Set(skillItems)];
      // console.log(' Final skills extracted:', uniqueSkills);
      return uniqueSkills;
    };

    jobData.skillRequired = extractSkills(normalizedText);



    // Quick test function to verify the extraction works with your format
    const testYourSkillsFormat = () => {
      const testText = "Required Skills - Technical Skills,Market Research & Data Analysis,Roadmapping,Communication,Leadership";
      // console.log(' Testing with your exact format:');
      // console.log('Input:', testText);

      const extractedSkills = extractSkills(testText);
      // console.log(' Extracted skills:', extractedSkills);

      return extractedSkills;
    };
    const extractFinancialData = (text) => {
      // console.log(' Extracting financial data...');


      const mixedPattern = /(\d+(?:,\d{3})*)\s*Job\s*Deadline[\s:]*([^\s]+)\s*Budget[\s:]*([^\s]+)/i;
      const mixedMatch = text.match(mixedPattern);

      if (mixedMatch) {
        jobData.salary = mixedMatch[1].trim();
        jobData.jobDeadline = mixedMatch[2].trim();
        jobData.budget = mixedMatch[3].trim();

        // console.log(' Salary found:', jobData.salary);
        // console.log(' Job Deadline found:', jobData.jobDeadline);
        // console.log(' Budget found:', jobData.budget);
        return;
      }

      const salaryPatterns = [
        /(?:Salary|Compensation|Pay)[\s:]*(\d+(?:,\d{3})*(?:\s*(?:lakh|L|k|K))?)/i,
        /₹?\s*(\d[\d,]*(?:\.\d+)?)\s*(?:lakh|L|k|K)?\s*(?:per|\/)\s*(?:month|year|annum)/i,
        /(Negotiable|Not Disclosed|As per industry standards)/i
      ];

      for (const pattern of salaryPatterns) {
        const match = text.match(pattern);
        if (match && match[1]) {
          jobData.salary = match[1].trim();
          // console.log(' Salary found:', jobData.salary);
          break;
        }
      }

      const budgetMatch = text.match(/Budget\s*[:\-]?\s*([\d\s\w]+)/i);
      if (budgetMatch && budgetMatch[1]) {
        extractedJobData.budget = budgetMatch[1].trim();
        // console.log('Extracted budget:', extractedJobData.budget);
      }


      const deadlineMatch = text.match(/(?:Job\s*)?Deadline[\s:]*([^\s\n]+)/i);
      if (deadlineMatch) {
        jobData.jobDeadline = deadlineMatch[1].trim();
        // console.log(' Job Deadline found:', jobData.jobDeadline);
      }
    };

    extractFinancialData(normalizedText);

    jobData.additionalDetails = extractAndClean([
      /(?:Additional Details|Additional Info|Notes)[\s:–—-]*(.*?)(?=\b(?:Experience Required|Experience|Salary|Job Deadline|Responsibilities|Skills|Working Arrangement|Work Location|City|Budget)\b)/i
    ], 'Additional Details');



    const descMatch = normalizedText.match(/(?:RESPONSIBILITIES|Job Description|Description|About the Role|WHAT WE'RE LOOKING FOR: )[\s:]*(.+?)(?=\n(?:SKILLS|EDUCATION|WORK EXPERIENCE|HOW TO APPLY)|$)/is);
    if (descMatch && descMatch[1]) {
      jobData.jobDescription = descMatch[1].trim().substring(0, 2000);
      // console.log(' Job Description found (length):', jobData.jobDescription.length);
    }

    // console.log(' Extraction Summary:');

    // Log all extracted data
    Object.entries(jobData).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            // console.log(`${key}: (${value.length} items)`, value);
          }
        } else {
          const displayValue = typeof value === 'string' && value.length > 100
            ? value.substring(0, 100) + '...'
            : value;
          // console.log(`${key}:`, displayValue);
        }
      }
    });

    return jobData;
  };


  // Helper function to detect work location type from text
  const detectWorkLocationType = (text) => {
    const lowerText = text.toLowerCase();
    if (lowerText.includes('remote work') || lowerText.includes('work from home')) {
      return 'Remote';
    } else if (lowerText.includes('hybrid')) {
      return 'Hybrid';
    } else if (lowerText.includes('on-site') || lowerText.includes('office')) {
      return 'On-site';
    }
    return null;
  };


  // Enhanced file upload handler with better error recovery
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      setError('Please select a file first');
      return;
    }



    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      setFileError('File size too large. Please select a file smaller than 10MB.');
      return;
    }

    // Validate file type
    const supportedTypes = [
      'text/plain',
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword'
    ];

    const supportedExtensions = ['.txt', '.pdf', '.doc', '.docx'];
    const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));

    if (!supportedTypes.includes(file.type) && !supportedExtensions.includes(fileExtension)) {
      setFileError('Unsupported file type. Please upload a TXT, PDF, DOC, or DOCX file.');
      return;
    }

    setUploadedFile(file);
    setLoading(true);
    setFileError('');
    setFileContent('');

    try {


      // Process file with timeout
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('File processing timeout (30 seconds)')), 30000)
      );

      const contentPromise = readFileContent(file);
      const content = await Promise.race([contentPromise, timeoutPromise]);

      if (!content || content.trim().length === 0) {
        throw new Error('No readable content found in the file');
      }

      setFileContent(content);

      // Extract comprehensive job data
      const jobData = extractJobData(content, file.name);

      if (jobData) {
        Object.entries(jobData).forEach(([key, value]) => {
          if (value !== null && value !== undefined) {
            if (Array.isArray(value)) {
              // console.log(`${key}:`, value.length > 0 ? value : 'Not found');
            } else {
              // console.log(`${key}:`, value);
            }
          }
        });
      }

    } catch (error) {
      // console.error(' Error processing file:', error);

      if (error.message.includes('timeout')) {
        setFileError('File processing timed out. The file might be too large or complex.');
      } else if (error.message.includes('PDF parsing')) {
        setFileError('PDF processing failed. Please try converting to a text file.');
      } else if (error.message.includes('Word document parsing')) {
        setFileError('Word document processing failed. Please try converting to a text file.');
      } else {
        setFileError(`Error processing file: ${error.message}`);
      }

      // Try fallback processing for text files
      if (file.type === 'text/plain' || file.name.toLowerCase().endsWith('.txt')) {
        // console.log(' Attempting fallback text processing...');
        try {
          const reader = new FileReader();
          const fallbackContent = await new Promise((resolve, reject) => {
            reader.onload = (e) => resolve(e.target.result);
            reader.onerror = reject;
            reader.readAsText(file);
          });

          setFileContent(fallbackContent);
          // console.log(' Fallback processing successful');
        } catch (fallbackError) {
          // console.error(' Fallback processing also failed:', fallbackError);
        }
      }

    } finally {
      setLoading(false);
      // console.log(' File processing completed');
    }
  };

  const handleCancelUpload = () => {
    // console.log(' Cancelling file upload');
    setUploadedFile(null);
    setFileContent('');
    setFileError('');
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const populateFormStateWithExtractedDataEnhanced = (extractedJobData) => {
    if (!extractedJobData) {
      // console.log(' No extracted data to populate');
      return;
    }

    // console.log(' Populating form state with extracted PDF data...');

    // Helper function to safely set values or null
    const safeSetValue = (setValue, value, fieldName) => {
      const cleanValue = value?.trim?.() || value;
      if (cleanValue && cleanValue !== '') {
        setValue(cleanValue);
        // console.log(` ${fieldName} updated:`, cleanValue);
      } else {
        setValue(null);
        // console.log(` ${fieldName} set to null (no valid data found)`);
      }
    };

    // Job Title
    safeSetValue(setJobTitle, extractedJobData.JobTitle, 'jobTitle');

    // Total Positions
    if (extractedJobData.totalPositions) {
      const positions = parseInt(extractedJobData.totalPositions, 10);
      if (!isNaN(positions) && positions > 0) {
        setTotalPositions(positions.toString()); // Store as string for form input
        // console.log(' totalPositions updated:', positions);
      } else {
        setTotalPositions(null);
        // console.log(' totalPositions set to null (invalid number:', extractedJobData.totalPositions, ')');
      }
    } else {
      setTotalPositions(null);
      // console.log(' totalPositions set to null (no data extracted)');
    }

    // Job Function (with dropdown matching)
    if (extractedJobData.jobFunction?.trim()) {
      let pdfValue = extractedJobData.jobFunction.trim().split(' -')[0].trim();
      const normalize = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
      const matched = dropDownValues?.jobFunctions?.find(item =>
        normalize(item.name) === normalize(pdfValue)
      );

      if (matched) {
        setJobFunction(matched.id);
        // console.log(' jobFunction matched from dropdown:', matched.name);
      } else {
        setJobFunction(null);
        // console.log(' jobFunction set to null (no dropdown match for:', pdfValue, ')');
      }
    } else {
      setJobFunction(null);
      // console.log(' jobFunction set to null (no data extracted)');
    }

    // Work Location Type (with dropdown matching)
    if (extractedJobData.workLocationType?.trim()) {
      let pdfValue = extractedJobData.workLocationType.trim().split(' -')[0].trim();
      const normalize = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
      const matched = dropDownValues?.workLocationTypes?.find(item =>
        normalize(item.name) === normalize(pdfValue)
      );

      if (matched) {
        setWorkLocationType(matched.id);
        // console.log(' workLocationType matched from dropdown:', matched.name);
      } else {
        setWorkLocationType(null);
        // console.log(' workLocationType set to null (no dropdown match for:', pdfValue, ')');
      }
    } else {
      setWorkLocationType(null);
      // console.log(' workLocationType set to null (no data extracted)');
    }

    // Job Type (with dropdown matching)
    if (extractedJobData.jobType?.trim()) {
      let pdfValue = extractedJobData.jobType.trim().split(' -')[0].trim();
      const normalize = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
      const matched = dropDownValues?.jobTypes?.find(item =>
        normalize(item.name) === normalize(pdfValue)
      );

      if (matched) {
        setJobType(matched.id);
        // console.log(' jobType matched from dropdown:', matched.name);
      } else {
        setJobType(null);
        // console.log(' jobType set to null (no dropdown match for:', pdfValue, ')');
      }
    } else {
      setJobType(null);
      // console.log(' jobType set to null (no data extracted)');
    }

    // Experience Level (with dropdown matching)
    if (extractedJobData.experienceLevel?.trim()) {
      const pdfValue = extractedJobData.experienceLevel.trim();
      const normalize = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
      const matched = dropDownValues?.experienceLevel?.find(item =>
        normalize(item.name) === normalize(pdfValue)
      );

      if (matched) {
        setExperienceLevel(matched.id);
        // console.log(' experienceLevel matched from dropdown:', matched.name);
      } else {
        setExperienceLevel(null);
        // console.log(' experienceLevel set to null (no dropdown match for:', pdfValue, ')');
      }
    } else {
      setExperienceLevel(null);
      // console.log(' experienceLevel set to null (no data extracted)');
    }

    // Job Description
    if (extractedJobData.jobDescription?.trim()) {
      const formatJobDescription = (rawText) => {
        if (!rawText) return '';
        let textWithBreaks = rawText.replace(/(\d+\.)\s*/g, '\n$1 ');
        textWithBreaks = textWithBreaks.replace(/(SKILLS AND QUALIFICATIONS:)/gi, '<p><strong>$1</strong></p>');
        const formattedList = textWithBreaks.replace(/^\s*\d+\.\s*(.+)$/gm, '<li>$1</li>');
        return `<ol>${formattedList}</ol>`;
      };

      const formattedDescription = formatJobDescription(extractedJobData.jobDescription.trim());
      setJobDescription(formattedDescription);
      // console.log(' jobDescription updated (formatted)');
    } else {
      setJobDescription(null);
      // console.log(' jobDescription set to null');
    }

    // Skills
    if (Array.isArray(extractedJobData.skillRequired) && extractedJobData.skillRequired.length > 0) {
      const cleanSkills = extractedJobData.skillRequired
        .filter(skill => typeof skill === 'string' && skill.trim().length > 1)
        .map(skill => skill.trim());

      if (cleanSkills.length > 0) {
        setSkillRequired(cleanSkills);
        // console.log(' skillRequired updated from array:', cleanSkills);
      } else {
        setSkillRequired([]);
        // console.log(' skillRequired set to empty array (no valid skills after filtering)');
      }
    } else if (typeof extractedJobData.skillRequired === 'string' && extractedJobData.skillRequired.trim()) {
      const skillsArray = extractedJobData.skillRequired
        .split(/[,;\n]/)
        .map(skill => skill.trim())
        .filter(skill => skill.length > 1);

      if (skillsArray.length > 0) {
        setSkillRequired(skillsArray);
        // console.log(' skillRequired updated from string:', skillsArray);
      } else {
        setSkillRequired([]);
        // console.log(' skillRequired set to empty array (no valid skills in string)');
      }
    } else {
      setSkillRequired([]);
      // console.log(' skillRequired set to empty array (no data extracted)');
    }

    // Simple text fields
    safeSetValue(setSalary, extractedJobData.salary, 'salary');
    safeSetValue(setCity, extractedJobData.city, 'city');
    safeSetValue(setBudget, extractedJobData.budget, 'budget');
    safeSetValue(setJobDeadline, extractedJobData.jobDeadline, 'jobDeadline');

    // Log final extraction summary
    const summary = getExtractionSummary();
    // console.log(` Extraction Summary: ${summary.extracted}/${summary.total} fields populated`);
    setTimeout(() => {
    }, 0);
  };
  const getExtractionSummary = () => {
    const allFields = [
      { field: jobTitle, name: 'Job Title' },
      { field: jobType, name: 'Job Type' },
      { field: city, name: 'City' },
      { field: workLocationType, name: 'Work Location' },
      { field: skillRequired, name: 'Skills' },
      { field: experienceLevel, name: 'Experience Level' },
      { field: jobFunction, name: 'Job Function' },
      { field: totalPositions, name: 'Total Positions' },
      { field: jobDescription, name: 'Job Description' },
      { field: jobDeadline, name: 'Job Deadline' },
      { field: budget, name: 'Budget' },
      { field: salary, name: 'Salary' }
    ];

    const summary = {
      total: allFields.length,
      extracted: 0,
      missing: 0,
      extractedFields: [],
      missingFields: []
    };

    allFields.forEach(item => {
      const hasValue = Array.isArray(item.field)
        ? item.field.length > 0
        : item.field !== null && item.field !== undefined && item.field?.toString().trim() !== '';

      if (hasValue) {
        summary.extracted++;
        summary.extractedFields.push(item.name);
      } else {
        summary.missing++;
        summary.missingFields.push(item.name);
      }
    });

    return summary;
  };
  const validateExtractedData = () => {
    const allFields = [
      { field: jobTitle, name: 'Job Title' },
      { field: jobType, name: 'Job Type' },
      { field: city, name: 'City' },
      { field: workLocationType, name: 'Work Location' },
      { field: skillRequired, name: 'Skills' },
      { field: experienceLevel, name: 'Experience Level' },
      { field: jobFunction, name: 'Job Function' },
      { field: totalPositions, name: 'Total Positions' },
      { field: jobDescription, name: 'Job Description' },
      { field: jobDeadline, name: 'Job Deadline' },
      { field: budget, name: 'Budget' },
      { field: salary, name: 'Salary' }
    ];

    // Separate fields into populated and missing
    const populatedFields = allFields.filter(item => {
      if (Array.isArray(item.field)) {
        return item.field.length > 0;
      }
      return item.field !== null && item.field !== undefined && item.field?.toString().trim() !== '';
    });

    const missingFields = allFields.filter(item => {
      if (Array.isArray(item.field)) {
        return item.field.length === 0;
      }
      return item.field === null || item.field === undefined || item.field?.toString().trim() === '';
    });

    // console.log(' PDF Extraction Results:');
    // console.log(` Populated fields (${populatedFields.length}):`);
    populatedFields.forEach(item => (`   - ${item.name}`));

    if (missingFields.length > 0) {
      // console.log(` Missing fields (${missingFields.length}):`);
      missingFields.forEach(item => (`   - ${item.name}`));
    }

    // Always return true to allow posting regardless of missing fields
    // console.log(' Proceeding with job post (missing fields will be set to null)');
    return true;
  };



  const handleSubmitJobFromPDF = async (isDraft = false) => {
    // console.log(' Submitting job post with PDF extracted data...');

    setIsSubmittingFromPDF(true);

    // Log current field values with better formatting
    const fieldValues = {
      jobTitle: jobTitle || null,
      totalPositions: totalPositions || null,
      jobFunction: jobFunction || null,
      workLocationType: workLocationType || null,
      jobType: jobType || null,
      experienceLevel: experienceLevel || null,
      city: city || null,
      jobDescription: jobDescription || null,
      skillRequired: skillRequired?.length > 0 ? skillRequired : null,
      salary: salary || null,
      budget: budget || null,
      jobDeadline: jobDeadline || null
    };

    // console.log(' Final job data being submitted:');
    Object.entries(fieldValues).forEach(([key, value]) => {
      if (value === null) {
        // console.log(`   ${key}: NULL`);
      } else if (Array.isArray(value)) {
        // console.log(`   ${key}: [${value.join(', ')}] (${value.length} items)`);
      } else if (typeof value === 'string' && value.length > 100) {
        // console.log(`   ${key}: "${value.substring(0, 100)}..." (${value.length} chars)`);
      } else {
        // console.log(`   ${key}: "${value}"`);
      }
    });

    // Always validate but allow bypass for PDF submissions
    const isValid = validateExtractedData();

    if (!isValid) {
      // console.error(' PDF data validation failed unexpectedly');
      setError('PDF data validation failed. Please try again.');
      setIsSubmittingFromPDF(false);
      return;
    }

    try {
      // console.log(' Calling handleSubmitJob with bypassValidation=true...');
      // Call handleSubmitJob with bypass validation flag
      await handleSubmitJob(isDraft, true);
      // console.log(' PDF job submission completed');
    } catch (error) {
      // console.error(' Error in handleSubmitJobFromPDF:', error);
      setError('Failed to submit job from PDF. Please try again.');
      setIsSubmittingFromPDF(false);
    }
  };

  const resetFormForNewPDF = () => {
    setJobTitle('');
    setTotalPositions('1');
    setJobFunction('');
    setWorkLocationType('');
    setJobType('');
    setExperienceLevel('');
    setJobDescription('');
    setSkillRequired([]);
    setSalary('');

    setUploadedFile(null);
    setFileContent('');
    setFileError('');
  };

  const previewFormData = () => {
    const formData = {
      jobTitle,
      totalPositions,
      jobFunction,
      workLocationType: workLocationType || null,
      jobType,
      experienceLevel,
      jobDescription: jobDescription ? jobDescription.substring(0, 200) + '...' : null,
      skillRequired,
      salary: salary || null
    };

    // console.log(' FORM DATA PREVIEW:');
    // console.table(formData);
    return formData;
  };
  const handleRedirectToForm = () => {
    setStep('form');
    window.scrollTo(0, 0);
  };
  const renderStepContent = () => {
    switch (step) {
      case 1:
        return (
          <Grid container direction="column" alignItems="center" spacing={3}>
            <Grid item xs={12} style={{ width: '100%', maxWidth: '500px', marginTop: '25px' }}>
              <TextRegular style={{ color: theme.palette.text.secondary, marginBottom: '6px' }}>
                Upload File
              </TextRegular>

              {!uploadedFile ? (
                <Button
                  variant="outlined"
                  component="label"
                  fullWidth
                  size="small"
                >
                  Choose File
                  <input
                    type="file"
                    hidden
                    onChange={handleFileUpload}
                    accept=".txt,.pdf,.doc,.docx"
                  />
                </Button>
              ) : (
                <div>
                  <div
                    style={{
                      padding: '8px 12px',
                      border: `1px solid ${theme.palette.success?.main || '#4caf50'}`,
                      borderRadius: '4px',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    <div
                      style={{
                        color: theme.palette.text.primary,
                        fontSize: '14px',
                        wordBreak: 'break-word',
                        flex: 1
                      }}
                    >
                      {uploadedFile.name}
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                      variant="outlined"
                      component="label"
                      size="small"
                      style={{ flex: 1 }}
                    >
                      Choose Different File
                      <input
                        type="file"
                        hidden
                        onChange={handleFileUpload}
                        accept=".txt,.pdf,.doc,.docx"
                      />
                    </Button>

                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => { handleCancelUpload(); resetFormForNewPDF(); }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              )}
              {uploadedFile && (
                <div style={{ marginTop: '16px' }}>
                  {loading ? (
                    <div style={{
                      padding: '16px',
                      textAlign: 'center',
                      color: theme.palette.text.secondary
                    }}>
                      <div style={{ marginBottom: '8px' }}>
                        {uploadedFile.type === 'application/pdf' ?
                          'Extracting PDF content...' :
                          'Reading file content...'
                        }
                      </div>
                      {uploadedFile.type === 'application/pdf' && (
                        <div style={{ fontSize: '12px', color: theme.palette.text.disabled }}>
                          Large PDFs may take up to 30 seconds to process
                        </div>
                      )}
                    </div>
                  ) : fileError ? (
                    <div style={{
                      padding: '16px',
                      backgroundColor: theme.palette.error?.light || '#ffebee',
                      border: `1px solid ${theme.palette.error?.main || '#f44336'}`,
                      borderRadius: '4px',
                      color: theme.palette.error?.main || '#f44336',
                      fontSize: '14px'
                    }}>
                      {fileError}
                    </div>
                  ) : null}
                </div>
              )}

              {uploadedFile && !loading && !fileError && (
                <div style={{ marginTop: '12px' }}>
                  <AppButton
                    variant='contained'
                    name='Continue'
                    onClick={async () => {
                      // Extract job data from the uploaded file
                      const jobData = extractJobData(fileContent, uploadedFile.name);
                      if (jobData) {
                        // Populate form state with extracted data
                        await populateFormStateWithExtractedDataEnhanced(jobData);
                        // Redirect to the form page
                        handleRedirectToForm();
                      } else {
                        // If no data could be extracted, still redirect to form
                        handleRedirectToForm();
                      }
                    }}
                    loading={jobPostLoading}
                  />
                </div>
              )}
            </Grid>

            <Grid item xs={12}>
              <TextRegular>OR</TextRegular>
            </Grid>

            <Grid item xs={12} style={{ width: '100%', maxWidth: '500px' }}>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => {
                  setStep(2);
                }}
              >
                Generate Job Description using AI
              </Button>
            </Grid>
          </Grid>
        );

      case 2:
        return (
          <Grid container direction='column'>
            <Grid item xs={12}>
              <FormControl fullWidth error={formError.jobTitle}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px',
                    textTransform: 'capitalize'
                  }}
                >
                  Job title *
                </TextRegular>
                <Autocomplete
                  freeSolo
                  options={jobRoles}
                  value={jobTitle}
                  onInputChange={(event, newInputValue) => {
                    if (newInputValue.length < 60) {
                      setJobTitle(newInputValue);
                    }
                  }}
                  onChange={(event, newValue) => {
                    if (newValue && newValue.length < 60) {
                      setJobTitle(newValue);
                    }
                  }}
                  filterOptions={(options, { inputValue }) => {
                    return options.filter(option =>
                      option.toLowerCase().includes(inputValue.toLowerCase())
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      fullWidth
                      error={formError.jobTitle}
                      helperText={formError.jobTitle}
                      placeholder="Start typing a job title..."
                    />
                  )}
                  noOptionsText="No matching job titles found"
                  clearOnEscape
                  selectOnFocus
                  handleHomeEndKeys
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth error={formError.jobType}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px',
                    marginTop: '20px',
                  }}
                >
                  Job type *
                </TextRegular>
                <Select
                  required
                  id='jobType'
                  value={jobType}
                  onChange={event => setJobType(event.target.value)}
                >
                  {dropDownValues?.jobTypes?.map(item => (
                    <MenuItem required value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formError.jobType}</FormHelperText>
              </FormControl>
            </Grid>
            <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>
              Example titles
            </p>
            <ul style={exampleList}>
              <li>React Native Developer For FinTech MVP</li>
              <li>Full-Stack Engineer to Scale a B2B SAAS</li>
              <li>Talent Acqusition Partner for early-stage startup</li>
              <li>Grapic Designer for social media and creatives</li>
              <li>Backend Developer for API integrations</li>
            </ul>
          </Grid>
        );
      case 'form':
        return (
          <Grid container direction='column' spacing={3}>
            {/* Header */}
            <Grid item xs={12}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '24px',
                padding: '16px',
                backgroundColor: theme.palette.background?.paper || '#f5f5f5',
                borderRadius: '8px',
                border: `1px solid ${theme.palette.divider || '#e0e0e0'}`
              }}>
                <div style={{ flex: 1 }}>
                  <TextRegular style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: theme.palette.text.primary,
                    marginBottom: '4px'
                  }}>
                    Job Details Form -- {`${uploadedFile.name}`}
                  </TextRegular>
                  <TextRegular style={{
                    fontSize: '14px',
                    color: theme.palette.text.secondary
                  }}>
                    {/* {uploadedFile ? 
                `Data extracted from: ${uploadedFile.name}. Please review and complete any missing information.` :
                'Please fill in the job details below.'
              } */}
                  </TextRegular>
                </div>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    setStep(1);
                  }}
                  style={{ marginLeft: '16px' }}
                >
                  Back to Upload
                </Button>
              </div>
              {/* Job Title */}
              <Grid item xs={12}>
                <FormControl fullWidth error={formError.jobTitle}>
                  <TextRegular
                    style={{
                      color: theme.palette.text.secondary,
                      marginBottom: '6px',
                      textTransform: 'capitalize'
                    }}
                  >
                    Job title *
                  </TextRegular>
                  <Autocomplete
                    freeSolo
                    options={jobRoles}
                    value={jobTitle}
                    onInputChange={(event, newInputValue) => {
                      if (newInputValue.length < 60) {
                        setJobTitle(newInputValue);
                      }
                    }}
                    onChange={(event, newValue) => {
                      if (newValue && newValue.length < 60) {
                        setJobTitle(newValue);
                      }
                    }}
                    filterOptions={(options, { inputValue }) => {
                      return options.filter(option =>
                        option.toLowerCase().includes(inputValue.toLowerCase())
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        fullWidth
                        error={formError.jobTitle}
                        helperText={formError.jobTitle || (jobTitle ? 'Extracted from file' : '')}
                        placeholder="Start typing a job title..."
                      />
                    )}
                    noOptionsText="No matching job titles found"
                    clearOnEscape
                    selectOnFocus
                    handleHomeEndKeys
                  />
                </FormControl>
                {/* Job Type */}
                <Grid item xs={12}>
                  <FormControl fullWidth error={formError.jobType}>
                    <TextRegular
                      style={{
                        color: theme.palette.text.secondary,
                        marginBottom: '6px',
                        textTransform: 'capitalize'
                      }}
                    >
                      Job type *
                    </TextRegular>
                    <Select
                      required
                      id='jobType'
                      value={jobType}
                      onChange={event => setJobType(event.target.value)}
                    >
                      {dropDownValues?.jobTypes?.map(item => (
                        <MenuItem key={item.id} required value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{formError.jobType}</FormHelperText>
                  </FormControl>
                </Grid>

                {/* City */}
                <Grid item xs={12}>
                  <FormControl fullWidth error={formError.city}>
                    <TextRegular
                      style={{
                        color: theme.palette.text.secondary,
                        marginBottom: '6px',
                        textTransform: 'capitalize'
                      }}
                    >
                      City
                    </TextRegular>
                    <TextField
                      value={city}
                      onChange={e => setCity(e.target.value)}
                      fullWidth
                      error={formError.city}
                      helperText={formError.city || (city ? 'Extracted from file' : '')}
                      placeholder="Enter city name"
                    />
                  </FormControl>
                  {/* Work Location Type */}
                  <Grid item xs={12}>
                    <FormControl fullWidth error={formError.workLocationType}>
                      <TextRegular
                        style={{
                          color: theme.palette.text.secondary,
                          marginBottom: '6px',
                          textTransform: 'capitalize'
                        }}
                      >
                        Work Location Type *
                      </TextRegular>
                      <Select
                        labelId='workLocationType-label'
                        value={workLocationType}
                        onChange={event => setWorkLocationType(event.target.value)}
                      >
                        {dropDownValues?.workLocationTypes?.map(item => (
                          <MenuItem key={item.id} required value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>{formError.workLocationType}</FormHelperText>
                    </FormControl>
                  </Grid>

                  {/* Skills */}
                  <Grid item xs={12}>
                    <FormControl fullWidth error={formError.skillRequired}>
                      <TextRegular
                        style={{
                          color: theme.palette.text.secondary,
                          marginBottom: '6px',
                          textTransform: 'capitalize'
                        }}
                      >
                        Skills *
                      </TextRegular>
                      <Box>
                        <TextField
                          placeholder='Press enter to enter multiple skills'
                          value={inputSkills}
                          onChange={event => {
                            const { value } = event.target
                            setInputSkills(value)
                          }}
                          onKeyDownCapture={event => {
                            setPopperClick(true)
                            handleEnterSkills(event, event.target.value)
                          }}
                          InputProps={{
                            disableUnderline: true
                          }}
                          sx={{
                            width: '100%'
                          }}
                          ref={containerRef}
                          onFocus={() => {
                            setOpenPopper(true)
                            setPopperClick(true)
                          }}
                          onBlur={() => {
                            if (popperClick) {
                              setOpenPopper(true)
                            } else {
                              setOpenPopper(false)
                            }
                          }}
                        />
                        {skillRequired?.map((skill, index) => (
                          <Chip
                            key={index}
                            label={skill}
                            onDelete={() => handleDeleteSkill(index)}
                            style={{
                              margin: '8px'
                            }}
                            sx={{
                              '& .MuiChip-deleteIcon': {
                                color: `${theme.palette.primary.main}`
                              }
                            }}
                          />
                        ))}
                      </Box>
                      <FormHelperText>
                        {formError.skillRequired || (skillRequired?.length > 0 ? 'Skills extracted from file' : '')}
                      </FormHelperText>
                    </FormControl>
                    {/* Experience Level */}
                    <Grid item xs={12}>
                      <FormControl fullWidth error={formError.experienceLevel}>
                        <TextRegular
                          style={{
                            color: theme.palette.text.secondary,
                            marginBottom: '6px',
                            textTransform: 'capitalize'
                          }}
                        >
                          Experience Level *
                        </TextRegular>
                        <Select
                          required
                          labelId="experienceLevel-label"
                          id="experienceLevel"
                          value={experienceLevel}
                          label="Experience Level"
                          onChange={e => setExperienceLevel(e.target.value)}
                        >
                          {/* Dynamically add PDF-extracted value if not in dropdown */}
                          {experienceLevel &&
                            !dropDownValues?.experienceLevel?.some(item => item.id === experienceLevel) && (
                              <MenuItem value={experienceLevel}>
                                {typeof experienceLevel === 'string' ? experienceLevel : 'Other'}
                              </MenuItem>
                            )}

                          {dropDownValues?.experienceLevel?.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>{formError.experienceLevel}</FormHelperText>
                      </FormControl>
                    </Grid>

                    {/* Job Function */}
                    <Grid item xs={12}>
                      <FormControl fullWidth error={formError.jobFunction}>
                        <TextRegular
                          style={{
                            color: theme.palette.text.secondary,
                            marginBottom: '6px',
                            textTransform: 'capitalize'
                          }}
                        >
                          Job Function *
                        </TextRegular>
                        <Select
                          required
                          id='jobFunction'
                          value={jobFunction}
                          onChange={event => setJobFunction(event.target.value)}
                        >
                          {dropDownValues?.jobFunctions?.map(item => (
                            <MenuItem key={item.id} required value={item.id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>{formError.jobFunction}</FormHelperText>
                      </FormControl>
                      {/* Total Positions */}
                      <Grid item xs={12}>
                        <FormControl fullWidth error={formError.totalPositions}>
                          <TextRegular
                            style={{
                              color: theme.palette.text.secondary,
                              marginBottom: '6px',
                              textTransform: 'capitalize'
                            }}
                          >
                            Total number of positions *
                          </TextRegular>
                          <Select
                            id='no-of-position'
                            value={totalPositions}
                            error={formError.totalPositions}
                            onChange={event => setTotalPositions(event.target.value)}
                            required
                          >
                            {Array.from({ length: 100 }, (_, i) => i + 1).map(number => (
                              <MenuItem key={number} value={number}>{number}</MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>{formError.totalPositions}</FormHelperText>
                        </FormControl>
                        {/* Job Description */}
                        <Grid item xs={12}>
                          <FormControl fullWidth error={formError.jobDescription}>
                            <TextRegular
                              style={{
                                color: theme.palette.text.secondary,
                                marginBottom: '6px',
                                textTransform: 'capitalize'
                              }}
                            >
                              Job Description *
                            </TextRegular>
                            <div
                              style={{
                                backgroundColor: '#ffffff'
                              }}
                            >
                              <TextEditor
                                getter={jobDescription}
                                setter={setJobDescription}
                                placeholder='Copy and paste the job description here.'
                                style={{ backgroundColor: '#ffffff' }}
                              />
                            </div>
                            <FormHelperText>
                              {formError.jobDescription || (jobDescription ? 'Content extracted from file' : '')}
                            </FormHelperText>
                          </FormControl>

                          {/* Deadline */}
                          <Grid item xs={12}>
                            <TextRegular
                              style={{
                                color: theme.palette.text.secondary,
                                marginBottom: '6px'
                              }}
                            >
                              Deadline *
                            </TextRegular>
                            <FormControl fullWidth error={formError.jobDeadline}>
                              <Select
                                id='job-deadline'
                                value={jobDeadline}
                                onChange={e => setJobDeadline(e.target.value)}
                                displayEmpty
                                size='small'
                              >
                                <MenuItem value='' disabled>Select deadline</MenuItem>
                                <MenuItem value='7_days'>7 Days</MenuItem>
                                <MenuItem value='14_days'>14 Days</MenuItem>
                                <MenuItem value='30_days'>30 Days</MenuItem>
                                <MenuItem value='custom'>Custom</MenuItem>
                              </Select>
                              <FormHelperText>{formError.jobDeadline}</FormHelperText>
                            </FormControl>
                          </Grid>

                          {/* Budget and Salary */}
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <TextRegular
                                  style={{
                                    color: theme.palette.text.secondary,
                                    marginBottom: '6px'
                                  }}
                                >
                                  Annual CTC *
                                </TextRegular>
                                <FormControl fullWidth error={formError.budget}>
                                  <TextField
                                    type='text'
                                    placeholder='Enter CTC here'
                                    value={budget}
                                    onChange={e => setBudget(e.target.value)}
                                    fullWidth
                                    size='small'
                                  />
                                  <FormHelperText>{formError.budget}</FormHelperText>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} md={6}>
                                <TextRegular
                                  style={{
                                    color: theme.palette.text.secondary,
                                    marginBottom: '6px'
                                  }}
                                >
                                  Salary *
                                </TextRegular>
                                <FormControl fullWidth error={formError.salary}>
                                  <TextField
                                    type='text'
                                    placeholder='Enter Salary here'
                                    value={salary}
                                    onChange={e => setSalary(e.target.value)}
                                    fullWidth
                                    size='small'
                                  />
                                  <FormHelperText>{formError.salary}</FormHelperText>
                                </FormControl>
                                {/* Submit Button */}
                                <Grid item xs={12}>
                                  <div style={{
                                    display: 'flex',
                                    gap: '12px',
                                    justifyContent: 'flex-end',
                                    marginTop: '24px',
                                    paddingTop: '24px',
                                    borderTop: `1px solid ${theme.palette.divider || '#e0e0e0'}`
                                  }}>
                                    <Dialog
                                      open={openJDDialog}
                                      onClose={() => setOpenJDDialog(false)}
                                      maxWidth="lg"
                                      fullWidth
                                    >
                                      <DialogTitle>Job Description Preview</DialogTitle>
                                      <DialogContent>
                                        <Grid container spacing={3} sx={{ mt: 1 }}>
                                          {/* Left Column - Form */}
                                          <Grid item xs={12} md={6}>
                                            <Box component="form" noValidate>
                                              <TextField
                                                label="Job Title"
                                                fullWidth
                                                margin="normal"
                                                value={jobTitle}
                                                onChange={(e) => setJobTitle(e.target.value)}
                                              />

                                              <FormControl fullWidth margin="normal">
                                                <InputLabel id="jobType-label">Job Type</InputLabel>
                                                <Select
                                                  required
                                                  labelId="jobType-label"
                                                  id="jobType"
                                                  value={jobType}
                                                  label="Job Type"
                                                  onChange={event => setJobType(event.target.value)}
                                                >
                                                  {dropDownValues?.jobTypes?.map(item => (
                                                    <MenuItem key={item.id} value={item.id}>
                                                      {item.name}
                                                    </MenuItem>
                                                  ))}
                                                </Select>
                                              </FormControl>

                                              <TextField
                                                label="City"
                                                fullWidth
                                                margin="normal"
                                                value={city}
                                                onChange={(e) => setCity(e.target.value)}
                                              />

                                              <FormControl fullWidth margin="normal">
                                                <InputLabel id="workLocationType-label">Work Location Type</InputLabel>
                                                <Select
                                                  labelId="workLocationType-label"
                                                  value={workLocationType}
                                                  label="Work Location Type"
                                                  onChange={event => setWorkLocationType(event.target.value)}
                                                >
                                                  {dropDownValues?.workLocationTypes?.map(item => (
                                                    <MenuItem key={item.id} value={item.id}>
                                                      {item.name}
                                                    </MenuItem>
                                                  ))}
                                                </Select>
                                              </FormControl>

                                              <TextField
                                                label="Skills"
                                                fullWidth
                                                margin="normal"
                                                value={skillRequired}
                                                onChange={(e) => setSkillRequired(e.target.value)}
                                                placeholder="Enter required skills (comma separated)"
                                              />

                                              <FormControl fullWidth margin="normal">
                                                <InputLabel id="experienceLevel-label">Experience Level</InputLabel>
                                                <Select
                                                  required
                                                  labelId="experienceLevel-label"
                                                  id="experienceLevel"
                                                  value={experienceLevel}
                                                  label="Experience Level"
                                                  onChange={e => setExperienceLevel(e.target.value)}
                                                >
                                                  {dropDownValues?.experienceLevel?.map(item => (
                                                    <MenuItem key={item.id} value={item.id}>
                                                      {item.name}
                                                    </MenuItem>
                                                  ))}
                                                </Select>
                                              </FormControl>

                                              <FormControl fullWidth margin="normal">
                                                <InputLabel id="jobFunction-label">Job Function</InputLabel>
                                                <Select
                                                  required
                                                  labelId="jobFunction-label"
                                                  id="jobFunction"
                                                  value={jobFunction}
                                                  label="Job Function"
                                                  onChange={event => setJobFunction(event.target.value)}
                                                >
                                                  {dropDownValues?.jobFunctions?.map(item => (
                                                    <MenuItem key={item.id} value={item.id}>
                                                      {item.name}
                                                    </MenuItem>
                                                  ))}
                                                </Select>
                                              </FormControl>

                                              <FormControl fullWidth margin="normal" error={formError?.totalPositions}>
                                                <InputLabel id="totalPositions-label">Total number of positions *</InputLabel>
                                                <Select
                                                  labelId="totalPositions-label"
                                                  id="totalPositions"
                                                  value={totalPositions}
                                                  label="Total number of positions *"
                                                  error={formError?.totalPositions}
                                                  onChange={event => setTotalPositions(event.target.value)}
                                                  required
                                                >
                                                  {Array.from({ length: 100 }, (_, i) => i + 1).map(number => (
                                                    <MenuItem key={number} value={number}>{number}</MenuItem>
                                                  ))}
                                                </Select>
                                                <FormHelperText>{formError?.totalPositions}</FormHelperText>
                                              </FormControl>
                                              <Grid item xs={12}>
                                                <TextRegular
                                                  style={{
                                                    color: theme.palette.text.secondary,
                                                    marginBottom: '6px'
                                                  }}
                                                >
                                                  Deadline *
                                                </TextRegular>

                                                <FormControl fullWidth error={formError.jobDeadline}>
                                                  <Select
                                                    id='job-deadline'
                                                    value={jobDeadline}
                                                    onChange={e => setJobDeadline(e.target.value)}
                                                    displayEmpty
                                                    size='small'
                                                  >
                                                    <MenuItem value='' disabled></MenuItem>
                                                    <MenuItem value='7_days'>7 Days</MenuItem>
                                                    <MenuItem value='14_days'>14 Days</MenuItem>
                                                    <MenuItem value='30_days'>30 Days</MenuItem>
                                                    <MenuItem value='custom'>Custom</MenuItem>
                                                  </Select>
                                                  <FormHelperText>{formError.jobDeadline}</FormHelperText>
                                                </FormControl>
                                                <TextRegular
                                                  style={{
                                                    color: theme.palette.text.secondary,
                                                    marginBottom: '6px'
                                                  }}
                                                >
                                                  Annual CTC *
                                                </TextRegular>
                                                <FormControl fullWidth error={formError.budget}>
                                                  <TextField
                                                    type='text'
                                                    placeholder='Enter CTC here'
                                                    value={budget}
                                                    onChange={e => setBudget(e.target.value)}
                                                    fullWidth
                                                    size='small'
                                                  />
                                                  <FormHelperText>{formError.budget}</FormHelperText>
                                                </FormControl>
                                                <TextRegular
                                                  style={{
                                                    color: theme.palette.text.secondary,
                                                    marginBottom: '6px'
                                                  }}
                                                >
                                                  Salary *
                                                </TextRegular>
                                                <FormControl fullWidth error={formError.salary}>
                                                  <TextField
                                                    type='text'
                                                    placeholder='Enter Salary here'
                                                    value={salary}
                                                    onChange={e => setSalary(e.target.value)}
                                                    fullWidth
                                                    size='small'
                                                  />
                                                  <FormHelperText>{formError.salary}</FormHelperText>
                                                </FormControl>
                                              </Grid>
                                            </Box>
                                          </Grid>

                                          {/* Right Column - Job Description */}
                                          <Grid item xs={12} md={6}>
                                            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                              <Dialog variant="h6" gutterBottom>
                                                Job Description Preview
                                              </Dialog>
                                              <Paper
                                                elevation={1}
                                                sx={{
                                                  flexGrow: 1,
                                                  p: 2,
                                                  minHeight: '400px',
                                                  backgroundColor: '#f9f9f9',
                                                  overflow: 'auto',
                                                  border: '1px solid #ddd',
                                                  borderRadius: 2
                                                }}
                                              >
                                                {jobDescription ? (
                                                  <Box
                                                    dangerouslySetInnerHTML={{ __html: jobDescription }}
                                                    sx={{
                                                      fontFamily: 'Arial, sans-serif',
                                                      fontSize: '14px',
                                                      lineHeight: 1.6,
                                                      overflowWrap: 'break-word'
                                                    }}
                                                  />
                                                ) : (
                                                  <Dialog
                                                    variant="body2"
                                                    color="text.secondary"
                                                    // onClick={generateDescription}
                                                    sx={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center',
                                                      height: '100%',
                                                      textAlign: 'center',
                                                      fontStyle: 'italic'
                                                    }}
                                                  >
                                                    Generated job description will appear here
                                                  </Dialog>
                                                )}
                                              </Paper>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </DialogContent>


                                      <DialogActions>
                                        <Button style={{ textTransform: 'initial' }} onClick={() => setOpenJDDialog(false)} color="secondary">
                                          Cancel
                                        </Button>
                                        <Button
                                          variant="contained"
                                          style={{ textTransform: 'initial' }}
                                          onClick={async () => {
                                            await handleSubmitJobFromPDF(false);
                                          }}
                                        >
                                          Post
                                        </Button>
                                      </DialogActions>
                                    </Dialog>
                                    <Button
                                      style={{ textTransform: 'initial' }}
                                      variant="outlined"
                                      onClick={() => {
                                        setStep(1);
                                      }}
                                      disabled={jobPostLoading}
                                    >
                                      Back
                                    </Button>
                                    {/* <Button
          style={{textTransform:'initial'}}
            variant="outlined"
            textTransform='initial'
             onClick={() =>}
            
          >
          Preview
          </Button> */}
                                    <AppButton
                                      variant='contained'
                                      name='Confirm & Post Job'
                                      onClick={async () => {
                                        setOpenJDDialog(true);
                                      }}
                                      loading={jobPostLoading}
                                    />
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )
      case 3:
        return (
          <>
            <FormControl fullWidth error={formError.city}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px',
                  textTransform: 'capitalize'
                }}
              >
                City
              </TextRegular>
              <TextField
                value={city}
                onChange={e => {
                  var { value } = e.target
                  setCity(e.target.value)
                }}
                fullWidth
                error={formError.city}
                helperText={formError.city}
              />
            </FormControl>
            <FormControl fullWidth error={formError.workLocationType}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px',
                  marginTop: '20px',
                  textTransform: 'capitalize'
                }}
              >
                Work Location Type *
              </TextRegular>
              <Select
                labelId='workLocationType-label'
                value={workLocationType}
                onChange={event => setWorkLocationType(event.target.value)}
              >
                {dropDownValues?.workLocationTypes?.map(item => (
                  <MenuItem required value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{formError.workLocationType}</FormHelperText>
            </FormControl>

            <FormControl fullWidth error={formError.skillRequired}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px',
                  marginTop: '20px',
                  textTransform: 'capitalize'
                }}
              >
                Skills *
              </TextRegular>
              <Box>
                <TextField
                  placeholder='Press enter to enter multiple skills'
                  value={inputSkills}
                  onChange={event => {
                    const { value } = event.target
                    setInputSkills(value)
                  }}
                  onKeyDownCapture={event => {
                    setPopperClick(true)
                    handleEnterSkills(event, event.target.value)
                  }}
                  InputProps={{
                    disableUnderline: true
                  }}
                  sx={{
                    width: '100%'
                  }}
                  ref={containerRef}
                  onFocus={() => {
                    setOpenPopper(true)
                    setPopperClick(true)
                  }}
                  onBlur={() => {
                    if (popperClick) {
                      setOpenPopper(true)
                    } else {
                      setOpenPopper(false)
                    }
                  }}
                />
                {skillRequired?.map((skill, index) => (
                  <Chip
                    key={index}
                    label={skill}
                    onDelete={() => handleDeleteSkill(index)}
                    style={{
                      margin: '8px'
                    }}
                    sx={{
                      '& .MuiChip-deleteIcon': {
                        color: `${theme.palette.primary.main}`
                      }
                    }}
                  />
                ))}
              </Box>
              <FormHelperText>{formError.skillRequired}</FormHelperText>
            </FormControl>
          </>
        );

      case 4:
        return (
          <>
            <FormControl fullWidth error={formError.experienceLevel}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px',
                  textTransform: 'capitalize'
                }}
              >
                Experience Level *
              </TextRegular>
              <Select
                required
                labelId="experienceLevel-label"
                id="experienceLevel"
                value={experienceLevel}
                label="Experience Level"
                onChange={e => setExperienceLevel(e.target.value)}
              >
                {/* Dynamically add PDF-extracted value if not in dropdown */}
                {experienceLevel &&
                  !dropDownValues?.experienceLevel?.some(item => item.id === experienceLevel) && (
                    <MenuItem value={experienceLevel}>
                      {typeof experienceLevel === 'string' ? experienceLevel : 'Other'}
                    </MenuItem>
                  )}

                {dropDownValues?.experienceLevel?.map(item => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{formError.experienceLevel}</FormHelperText>
            </FormControl>

            <FormControl fullWidth error={formError.jobFunction}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px',
                  marginTop: '20px',
                  textTransform: 'capitalize'
                }}
              >
                Job Function *
              </TextRegular>
              <Select
                required
                id='jobFunction'
                value={jobFunction}
                onChange={event => setJobFunction(event.target.value)}
              >
                {dropDownValues?.jobFunctions?.map(item => (
                  <MenuItem required value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{formError.jobFunction}</FormHelperText>
            </FormControl>

            <FormControl fullWidth error={formError.totalPositions}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px',
                  marginTop: '20px',
                  textTransform: 'capitalize'
                }}
              >
                Total number of positions *
              </TextRegular>
              <Select
                id='no-of-position'
                value={totalPositions}
                error={formError.totalPositions}
                onChange={event => setTotalPositions(event.target.value)}
                required
              >
                {Array.from({ length: 100 }, (_, i) => i + 0).map(number => (
                  <MenuItem value={number}>{number}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{formError.totalPositions}</FormHelperText>
            </FormControl>
          </>
        );

      case 5:
        // Budget, Salary, and Deadline
        return (
          <Grid container direction='column' spacing={2}>
            <Grid item xs={12}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                Annual CTC *
              </TextRegular>
              <FormControl fullWidth error={formError.budget}>
                <TextField
                  type='text'
                  placeholder='Enter CTC here'
                  value={budget}
                  onChange={e => setBudget(e.target.value)}
                  fullWidth
                  size='small'
                />
                <FormHelperText>{formError.budget}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                Salary *
              </TextRegular>
              <FormControl fullWidth error={formError.salary}>
                <TextField
                  type='text'
                  placeholder='Enter Salary here'
                  value={salary}
                  onChange={e => setSalary(e.target.value)}
                  fullWidth
                  size='small'
                />
                <FormHelperText>{formError.salary}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                Deadline *
              </TextRegular>
              <FormControl fullWidth error={formError.jobDeadline}>
                <Select
                  id='job-deadline'
                  value={jobDeadline}
                  onChange={e => setJobDeadline(e.target.value)}
                  displayEmpty
                  size='small'
                >
                  <MenuItem value='' disabled></MenuItem>
                  <MenuItem value='7_days'>7 Days</MenuItem>
                  <MenuItem value='14_days'>14 Days</MenuItem>
                  <MenuItem value='30_days'>30 Days</MenuItem>
                  <MenuItem value='custom'>Custom</MenuItem>
                </Select>
                <FormHelperText>{formError.jobDeadline}</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        );

      case 6:
        // Job Description with AI Generator
        return (
          <Grid container direction='column'>
            <Grid item xs={12} sx={{ marginBottom: '20px' }}>
              <FormControl fullWidth error={formError.jobDescription}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px',
                    textTransform: 'capitalize'
                  }}
                >
                  Job Description *
                </TextRegular>
                <div
                  style={{
                    backgroundColor: '#ffffff'
                  }}
                >
                  <TextEditor
                    getter={jobDescription}
                    setter={setJobDescription}
                    placeholder='Copy and paste the job description here.'
                    style={{ backgroundColor: '#ffffff' }}
                  />
                </div>
                <FormHelperText>{formError.jobDescription}</FormHelperText>
              </FormControl>
            </Grid>

            <AppButton
              variant='texts'
              onClick={() => setOpenJDDialog(true)}
              style={{
                width: 'fit-content',
                color: '#EC6529',
                fontSize: '14px',
                fontFamily: 'Manrope',
                textTransform: 'none',
                marginBottom: '20px'
              }}
              name='Generate the Job Description'
            />

            <Dialog
              open={openJDDialog}
              onClose={() => setOpenJDDialog(false)}
              maxWidth="lg"
              fullWidth
            >
              <DialogTitle>Generate Job Description</DialogTitle>
              <DialogContent>
                <Grid container spacing={3} sx={{ mt: 1 }}>
                  {/* Left Column - Form */}
                  <Grid item xs={12} md={6}>
                    <Box component="form" noValidate>
                      <TextField
                        label="Job Title"
                        fullWidth
                        margin="normal"
                        value={jobTitle}
                        onChange={(e) => setJobTitle(e.target.value)}
                      />

                      <FormControl fullWidth margin="normal">
                        <InputLabel id="jobType-label">Job Type</InputLabel>
                        <Select
                          required
                          labelId="jobType-label"
                          id="jobType"
                          value={jobType}
                          label="Job Type"
                          onChange={event => setJobType(event.target.value)}
                        >
                          {dropDownValues?.jobTypes?.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <TextField
                        label="City"
                        fullWidth
                        margin="normal"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                      />

                      <FormControl fullWidth margin="normal">
                        <InputLabel id="workLocationType-label">Work Location Type</InputLabel>
                        <Select
                          labelId="workLocationType-label"
                          value={workLocationType}
                          label="Work Location Type"
                          onChange={event => setWorkLocationType(event.target.value)}
                        >
                          {dropDownValues?.workLocationTypes?.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <TextField
                        label="Skills"
                        fullWidth
                        margin="normal"
                        value={skillRequired}
                        onChange={(e) => setSkillRequired(e.target.value)}
                        placeholder="Enter required skills (comma separated)"
                      />

                      <FormControl fullWidth margin="normal">
                        <InputLabel id="experienceLevel-label">Experience Level</InputLabel>
                        <Select
                          required
                          labelId="experienceLevel-label"
                          id="experienceLevel"
                          value={experienceLevel}
                          label="Experience Level"
                          onChange={e => setExperienceLevel(e.target.value)}
                        >
                          {dropDownValues?.experienceLevel?.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl fullWidth margin="normal">
                        <InputLabel id="jobFunction-label">Job Function</InputLabel>
                        <Select
                          required
                          labelId="jobFunction-label"
                          id="jobFunction"
                          value={jobFunction}
                          label="Job Function"
                          onChange={event => setJobFunction(event.target.value)}
                        >
                          {dropDownValues?.jobFunctions?.map(item => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl fullWidth margin="normal" error={formError?.totalPositions}>
                        <InputLabel id="totalPositions-label">Total number of positions *</InputLabel>
                        <Select
                          labelId="totalPositions-label"
                          id="totalPositions"
                          value={totalPositions}
                          label="Total number of positions *"
                          error={formError?.totalPositions}
                          onChange={event => setTotalPositions(event.target.value)}
                          required
                        >
                          {Array.from({ length: 100 }, (_, i) => i + 1).map(number => (
                            <MenuItem key={number} value={number}>{number}</MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>{formError?.totalPositions}</FormHelperText>
                      </FormControl>
                      <TextField
                        label="Annual CTC"
                        fullWidth
                        margin="normal"
                        value={budget}
                        onChange={(e) => setBudget(e.target.value)}
                        placeholder="Enter Annual CTC"
                      />
                      <TextField
                        label="Salary"
                        fullWidth
                        margin="normal"
                        value={salary}
                        onChange={(e) => setSalary(e.target.value)}
                        placeholder="Enter Salary"
                      />
                      <FormControl fullWidth margin="normal">
                        <InputLabel id="deadline-label">Deadline</InputLabel>
                        <Select
                          labelId="deadline-label"
                          value={jobDeadline}
                          label="Deadline"
                          onChange={e => setJobDeadline(e.target.value)}
                          displayEmpty
                        >
                          <MenuItem value=''>Select Deadline</MenuItem>
                          <MenuItem value='7_days'>7 Days</MenuItem>
                          <MenuItem value='14_days'>14 Days</MenuItem>
                          <MenuItem value='30_days'>30 Days</MenuItem>
                          <MenuItem value='custom'>Custom</MenuItem>
                        </Select>
                      </FormControl>
                      <TextField
                        label="Additional Details"
                        fullWidth
                        multiline
                        rows={3}
                        margin="normal"
                        value={additionalDetails}
                        onChange={(e) => setAdditionalDetails(e.target.value)}
                        placeholder="Benefits, company culture, etc."
                      />

                      <Button
                        variant="outlined"
                        fullWidth
                        textTransform="normal"
                        sx={{ mt: 3 }}
                        onClick={generateDescription}
                        disabled={!jobTitle || loading}
                      >
                        {loading && <CircularProgress size={20} sx={{ mr: 1 }} />}
                        {loading ? 'Generating...' : 'Generate Job Description'}
                      </Button>

                      {error && (
                        <Alert severity="error" sx={{ mt: 2 }}>
                          {error}
                        </Alert>
                      )}
                    </Box>
                  </Grid>

                  {/* Right Column - Job Description Preview */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                      <Dialog variant="h6" gutterBottom>
                        Job Description Preview
                      </Dialog>
                      <Paper
                        elevation={1}
                        sx={{
                          flexGrow: 1,
                          p: 2,
                          minHeight: '400px',
                          backgroundColor: '#f9f9f9',
                          overflow: 'auto',
                          border: '1px solid #ddd',
                          borderRadius: 2
                        }}
                      >
                        {jobDescription ? (
                          <Box
                            dangerouslySetInnerHTML={{ __html: jobDescription }}
                            sx={{
                              fontFamily: 'Arial, sans-serif',
                              fontSize: '14px',
                              lineHeight: 1.6,
                              overflowWrap: 'break-word'
                            }}
                          />
                        ) : (
                          <Dialog
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              height: '100%',
                              textAlign: 'center',
                              fontStyle: 'italic'
                            }}
                          >
                            Generated job description will appear here
                          </Dialog>
                        )}
                      </Paper>
                    </Box>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button onClick={() => setOpenJDDialog(false)} color="secondary">
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    if (jobDescription) {
                      const plainText = htmlToPlainText(jobDescription);
                      navigator.clipboard.writeText(plainText)
                        .then(() => {
                          // Success
                        })
                        .catch((err) => {
                          try {
                            const textArea = document.createElement('textarea');
                            textArea.value = plainText;
                            textArea.style.position = 'fixed';
                            textArea.style.opacity = '0';
                            document.body.appendChild(textArea);
                            textArea.select();
                            document.execCommand('copy');
                            document.body.removeChild(textArea);
                          } catch (fallbackErr) {
                            // Handle error
                          }
                        });
                    }
                  }}
                  disabled={!jobDescription}
                >
                  Copy
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        );

      default:
        return null;
    }
  }

  const getStepHeading = step => {
    switch (step) {
      case 1:
        return 'Upload your job description and Post the Job for Free ';
      case 2:
        return 'Lets start with a strong title.';
      case 3:
        return 'Where will they work, and what should they know?';
      case 4:
        return 'One role or many, junior or pro we got you.';
      case 5:
        return 'Describe the position clearly';
      case 6:
        return 'Set your budget and post';
      default:
        return 'Lets continue building your job post';
    }
  };

  const getStepSubText = step => {
    switch (step) {
      case 1:
        return 'Simply upload your job description file and our AI will extract all the details to create a perfect job posting.';
      case 2:
        return 'This is the first thing our AI and recruiters will see. Make it clear and specific it leads the way.';
      case 3:
        return 'Add key skills to help us match you with the right recruiters and candidates.';
      case 4:
        return 'Add key skills to help us match you with the right recruiters and candidates.';
      case 5:
        return 'Share job description and deadline.';
      case 6:
        return 'Finalize the budget and post your job.';
      default:
        return 'This helps your job post stand out to the right candidates.';
    }
  };

  const validateStep = () => {
    const errors = {}

    switch (step) {
      case 2:
        if (!jobTitle?.trim()) errors.jobTitle = 'Job title is required'
        if (!jobType) errors.jobType = 'Job type is required'
        break

      case 3:
        if (!city?.trim()) errors.city = 'Please enter city'
        if (!workLocationType)
          errors.workLocationType = 'Work location type is required'
        if (!Array.isArray(skillRequired) || skillRequired.length === 0) {
          errors.skillRequired = 'Press enter to add skills.'
        }
        break

      case 4:
        if (!experienceLevel)
          errors.experienceLevel = 'Experience level is required'
        if (!totalPositions) errors.totalPositions = 'Position is required'
        if (!jobFunction || isEmpty(jobFunction)) {
          errors.jobFunction = 'Please select job function'
        }
        break

      case 5:
        if (!budget) errors.budget = 'Budget is required'
        if (!salary) errors.salary = 'salary is required'
        if (!jobDeadline) errors.jobDeadline = 'Deadline must be selected'
        break

      case 6:
        if (!jobDescription?.trim())
          errors.jobDescription = 'Job description is required'
        break

      default:
        break
    }

    setFormError(errors)
    return Object.keys(errors).length === 0
  }

  return (
    <Grid>
      {/* <Grid item xs={10} style={{ padding: '0px' }}> */}
      <Grid
        container
        style={{
          display: 'flex',
          justifyContent: 'center'
          // height: isMobile? '55':'calc(100vh - 325px)'
        }}
      >
        <Grid container style={mainSection}>
          {/* Left Side */}
          <Grid item xs={12} md={4} style={leftSide}>
            <Grid>
              {step !== 'form' && (
                <TextRegular sx={{ color: '#888', fontSize: '14px' }}>
                  {step}/6 Job Post
                </TextRegular>
              )}
            </Grid>
            <Grid sx={{ margin: '20px 0 30px' }}>
              <TextBold
                sx={{
                  fontSize: isMobile ? '20px' : '28px',
                  lineHeight: 'normal'
                }}
              >
                {getStepHeading(step)}
              </TextBold>
            </Grid>
            <TextRegular>{getStepSubText(step)}.</TextRegular>
          </Grid>

          <Grid item md={2}></Grid>
          {/* Right Side */}
          <Grid item xs={12} md={6} style={rightSide}>
            {renderStepContent()}
          </Grid>
        </Grid>
      </Grid>

      {/* Progress Bar */}
      <div style={progressBarContainer}>
        <div style={progressBarFill}></div>
      </div>
      {/* Buttons */}
      <Grid
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <AppButton
          variant='text'
          onClick={() => {
            navigate('/employer/dashboard');
          }}
          style={{
            width: 'fit-content',
            backgroundColor: 'transparent',
            color: '#EC6529',
            fontSize: '16px',
            fontFamily: 'Manrope',
            textTransform: 'none'
          }}
          name='Skip'
        />

        {step > 1 && (
          <AppButton
            variant='contained'
            onClick={() => setStep(step - 1)}
            style={{
              backgroundColor: '#ccc',
              color: '#000',
              width: 'fit-content'
            }}
            name='Back'
          />
        )}
        {step < totalSteps ? (
          step !== 1 ? (
            <AppButton
              variant='contained'
              onClick={() => {
                if (validateStep()) {
                  setStep(step + 1)
                }
              }}
              name='Next'
              style={{ width: 'fit-content' }}
            />
          ) : null
        ) : (
          <>
            {!data?.isEdit ? (
              <AppButton
                variant='contained'
                name={'Save and post'}
                style={{ width: 'fit-content' }}
                disabled={false}
                loading={jobPostLoading}
                onClick={() => handleSubmitJob(false)}
              />
            ) : (
              <Grid container style={{ justifyContent: 'flex-end' }}>
                <Grid>
                  <AppButton
                    variant='contained'
                    name={'Update'}
                    disabled={false}
                    loading={jobUpdateLoading}
                    onClick={() => handleSubmitJob()}
                  />
                </Grid>
                <Grid style={{ marginLeft: '10px' }}>
                  <Button
                    variant='contained'
                    style={{ textTransform: 'none' }}
                    onClick={() => {
                      navigate('/employer/managejob')
                    }}
                  >
                    Go Back
                  </Button>
                </Grid>
              </Grid>
            )}
          </>
        )}
      </Grid>

      {/* OLD code commented here */}
      <Grid item xs={12} style={{ display: 'none' }}>
        <TextBold style={{ fontSize: '30px' }}>Post a Job</TextBold>
      </Grid>
      {/* <Grid item xs={12} style={{ padding: '0px' }}>
        <Divider />
      </Grid> */}

      <Grid container spacing={3} style={{ display: 'none' }}>
        <Grid item xs={6}>
          <FormControl fullWidth error={formError.jobTitle}>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px',
              }}
            >
              Job title*
            </TextRegular>
            <TextField
              required
              fullWidth
              value={jobTitle}
              error={formError.jobTitle}
              helperText={formError.jobTitle}
              onChange={e => {
                var { value } = e.target
                if (value.length < 60) {
                  setJobTitle(e.target.value)
                }
              }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={6} style={{ display: 'none' }}>
          <FormControl fullWidth error={formError.totalPositions}>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px'
              }}
            >
              Total number of positions *
            </TextRegular>
            <Select
              id='no-of-position'
              value={totalPositions}
              error={formError.totalPositions}
              onChange={event => setTotalPositions(event.target.value)}
              required
            >
              {Array.from({ length: 100 }, (_, i) => i + 1).map(number => (
                <MenuItem value={number}>{number}</MenuItem>
              ))}
            </Select>
            <FormHelperText>{formError.totalPositions}</FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={6} style={{ display: 'none' }}>
          <FormControl fullWidth error={formError.jobFunction}>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px'
              }}
            >
              Job Function *
            </TextRegular>
            <Select
              required
              id='jobFunction'
              value={jobFunction}
              onChange={event => setJobFunction(event.target.value)}
            >
              {dropDownValues?.jobFunctions?.map(item => (
                <MenuItem required value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{formError.jobFunction}</FormHelperText>
          </FormControl>
        </Grid>

        {/* <Grid item xs={6}>
              <FormControl fullWidth error={formError.country}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  Country *
                </TextRegular>
                <Select
                  required
                  id='Country'
                  value={country}
                  onChange={event => setCountry(event.target.value)}
                >
                  {dropDownValues?.countries?.map(item => (
                    <MenuItem required value={item.iso}>
                      {item.nicename}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formError.country}</FormHelperText>
              </FormControl>
            </Grid> */}
        {/* 
            <Grid item xs={6}>
              <FormControl fullWidth error={formError.zipCode}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  Zip Code *
                </TextRegular>
                <TextField
                  required
                  value={zipCode}
                  error={formError.zipCode}
                  helperText={formError.zipCode}
                  onChange={e => {
                    const input = e.target.value.replace(/\D/g, '')
                    if (input.length < 12) {
                      setZipCode(input)
                    }
                  }}
                  onBlur={() => {
                    if (zipCode.length > 3) {
                      getStateAndCityByZipcode()
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        {zipCodeLoading && <CircularProgress size={24} />}
                      </InputAdornment>
                    )
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth error={formError.city}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  City
                </TextRegular>
                <TextField
                  value={city}
                  onChange={e => {
                    const input = e.target.value
                      .replace(/[!@#$%^&*(),.?":{}|<>]/, '')
                      .replace(/\d/g, '')
                    if (input.length < 50) {
                      setCity(input)
                    }
                  }}
                  fullWidth
                  error={formError.city}
                  helperText={formError.city}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth error={formError.state}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  State
                </TextRegular>
                <TextField
                  value={state}
                  onChange={e => {
                    const input = e.target.value
                      .replace(/[!@#$%^&*(),.?":{}|<>]/, '')
                      .replace(/\d/g, '')
                    if (input.length < 30) {
                      setState(input)
                    }
                  }}
                  fullWidth
                  error={formError.state}
                  helperText={formError.state}
                />
              </FormControl>
            </Grid> */}

        <Grid item xs={6} style={{ display: 'none' }}>
          <FormControl fullWidth error={formError.workLocationType}>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px'
              }}
            >
              Work Location Type *
            </TextRegular>
            <Select
              labelId='workLocationType-label'
              value={workLocationType}
              onChange={event => setWorkLocationType(event.target.value)}
            >
              {dropDownValues?.workLocationTypes?.map(item => (
                <MenuItem required value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{formError.workLocationType}</FormHelperText>
          </FormControl>

          {/* <TextField
                fullWidth
                value={workLocationInfo}
                onChange={e => {
                  const input = e.target.value.replace(
                    /[!@#$%^&*(),.?":{}|<>]/,
                    ''
                  )
                  if (input.length < 100) {
                    setWorkLocationInfo(input)
                  }
                }}
                sx={{
                  marginTop: '10px'
                }}
                size='small'
                placeholder='Additional work location information'
              /> */}
        </Grid>

        {/* <Grid item xs={6}>
              <FormControl fullWidth error={formError.relocationAssistance}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  Relocation assistance *
                </TextRegular>
                <Select
                  id='relocationAssistance'
                  value={relocationAssistance || ''}
                  onChange={event =>
                    setRelocationAssistance(event.target.value)
                  }
                >
                  {dropDownValues?.relocationAssistance?.map(item => (
                    <MenuItem required value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {formError.relocationAssistance}
                </FormHelperText>
              </FormControl>

              <TextField
                fullWidth
                value={jobRelocationAssistanceText}
                onChange={e => {
                  const input = e.target.value.replace(
                    /[!@#$%^&*(),.?":{}|<>]/,
                    ''
                  )
                  if (input.length < 100) {
                    setJobRelocationAssistanceText(input)
                  }
                }}
                sx={{
                  marginTop: '10px'
                }}
                size='small'
                placeholder='Additional relocation assistance information'
              />
            </Grid> */}

        <Grid
          item
          xs={12}
          style={{ margin: '32px 0px 8px', paddingTop: '0px' }}
        >
          <Divider />
        </Grid>

        <Grid item xs={6} style={{ display: 'none' }}>
          <FormControl fullWidth error={formError.jobType}>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px'
              }}
            >
              Job type *
            </TextRegular>
            <Select
              required
              id='jobType'
              value={jobType}
              onChange={event => setJobType(event.target.value)}
            >
              {dropDownValues?.jobTypes?.map(item => (
                <MenuItem required value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{formError.jobType}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} style={{ display: 'none' }}>
          {jobType === JobTypes.Contract && (
            <Grid container spacing={3}>
              <Grid item xs={6} style={{ display: 'flex' }}>
                <FormControl
                  error={formError.contractDuration}
                  style={{ marginRight: '24px' }}
                >
                  <TextRegular
                    style={{
                      color: theme.palette.text.secondary,
                      marginBottom: '6px'
                    }}
                  >
                    Duration *
                  </TextRegular>
                  <TextField
                    required
                    error={formError.contractDuration}
                    helperText={formError.contractDuration}
                    value={contractDuration}
                    onChange={e => setContractDuration(e.target.value)}
                    sx={{
                      width: '12rem'
                    }}
                  />
                </FormControl>
                <FormControl
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                    marginBottom: '3px'
                  }}
                >
                  <Select
                    required
                    id='durationType'
                    value={durationType}
                    onChange={e => setDurationType(e.target.value)}
                    sx={{
                      width: '12rem'
                    }}
                  >
                    <MenuItem required value={'month'}>
                      Months
                    </MenuItem>
                    <MenuItem required value={'year'}>
                      Year
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} style={{ display: 'none' }}>
                <FormControl fullWidth error={formError.desiredStartDate}>
                  <TextRegular
                    style={{
                      color: theme.palette.text.secondary,
                      marginBottom: '6px'
                    }}
                  >
                    Desired start date *
                  </TextRegular>
                  <DatePicker
                    value={desiredStartDate}
                    onChange={date => {
                      if (date) {
                        // setDesiredStartDate(dayjs(date).format('MM/DD/YYYY'))
                        setDesiredStartDate(dayjs(date))
                      }
                    }}
                    renderInput={params => (
                      <TextField
                        sx={{ width: '100%' }}
                        error={formError?.desiredStartDate}
                        helperText={formError?.desiredStartDate}
                        {...params}
                      />
                    )}
                  />

                  <FormHelperText>{formError.desiredStartDate}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={6} style={{ display: 'none' }}>
                <FormControl fullWidth error={formError.supplierLimit}>
                  <TextRegular
                    style={{
                      color: theme.palette.text.secondary,
                      marginBottom: '6px'
                    }}
                  >
                    Candidate submission limit per supplier *
                  </TextRegular>
                  <TextField
                    required
                    fullWidth
                    value={supplierLimit}
                    error={formError.supplierLimit}
                    helperText={formError.supplierLimit}
                    onChange={e => {
                      const input = e.target.value.replace(/\D/g, '')
                      if (input.length < 5) {
                        setSupplierLimit(input)
                      }
                    }}
                    sx={{
                      width: '100%'
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6} style={{ display: 'none' }}>
                <FormControl fullWidth style={{ marginRight: '16px' }}>
                  <TextRegular
                    style={{
                      color: theme.palette.text.secondary,
                      marginBottom: '6px'
                    }}
                  >
                    Additional Compensation *
                  </TextRegular>
                  <TextField
                    value={jobBenefits}
                    onChange={e => {
                      var { value } = e.target
                      if (value.length < 100) {
                        setJobBenefits(e.target.value)
                      }
                    }}
                    sx={{
                      width: '100%',
                      marginRight: '10px'
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          )}
          {(jobType === JobTypes.DirectHire ||
            jobType === JobTypes.PartTime ||
            jobType === JobTypes.SourceAndScreen ||
            jobType === '') && (
              <Grid xs={6} container>
                <Grid item xs={12}>
                  <TextRegular
                    style={{
                      color: theme.palette.text.secondary
                    }}
                  >
                    Annual Compensation
                  </TextRegular>
                </Grid>

                <Grid item xs={6} style={{ marginTop: '10px', paddingRight: 24 }}>
                  <FormControl fullWidth>
                    <InputLabel id='From'>From</InputLabel>
                    <Select
                      label='From'
                      label-id='From'
                      value={jobCompensationAmountMin || ''}
                      onChange={e => setJobCompensationAmountMin(e.target.value)}
                    >
                      {fromCompensationValues().map(item => (
                        <MenuItem required key={item?.value} value={item?.value}>
                          {currencySymbol} {formatNumber(parseInt(item?.value))}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: 'none',
                    marginTop: '10px',
                    paddingRight: 14
                  }}
                >
                  <FormControl error={formError.jobCompensation} fullWidth>
                    <InputLabel id='To'>To</InputLabel>
                    <Select
                      required
                      id='To'
                      label='To'
                      label-id='To'
                      value={jobCompensationAmountMax || ''}
                      onChange={e => setJobCompensationAmountMax(e.target.value)}
                    >
                      {toCompensationValue().map(item => (
                        <MenuItem required key={item?.value} value={item?.value}>
                          {currencySymbol} {formatNumber(parseInt(item?.value))}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{formError.jobCompensation}</FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={12} style={{ display: 'none' }}>
                  <TextField
                    placeholder='Additional Compensation'
                    value={jobCompensationText}
                    onChange={e => {
                      const input = e.target.value.replace(/\D/g, '')
                      if (input.length < 100) {
                        setJobCompensationText(input)
                      }
                    }}
                    sx={{
                      width: '100%',
                      marginTop: '10px',
                      paddingRight: '13px'
                    }}
                    size='small'
                  />
                </Grid>
              </Grid>
            )}
          {jobType === JobTypes.Sourcing && (
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',

                flexDirection: 'column'
              }}
            >
              {rejectionReasons?.map((item, index) =>
                item.isUserDefined ? (
                  <Grid
                    container
                    style={{
                      display: 'flex',
                      border: `1px solid ${theme.palette.border.main}`,
                      padding: '24px 16px',
                      marginTop: '24px'
                    }}
                  >
                    {/* <Grid item xs={12}>
                          <IconButton
                            size='16'
                            onClick={() => {
                              const reasons = [...rejectionReasons]
                              reasons.splice(index, 1)
                              setRejectionReasons(reasons)
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid> */}

                    <Grid item xs={6} style={{ display: 'none' }}>
                      <TextRegular
                        style={{
                          fontSize: '16px',
                          marginBottom: '6px',
                          color: theme.palette.text.secondary
                        }}
                      >
                        Reject reason
                      </TextRegular>

                      <TextField
                        size='small'
                        placeholder={'Please enter reject reason'}
                        onChange={e => {
                          const { value } = e.target
                          if (value.length < 5) {
                            const reasons = [...rejectionReasons]
                            reasons[index].reason = value
                            setRejectionReasons(reasons)
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position='end'>
                              <IconButton
                                size='16'
                                onClick={() => {
                                  const reasons = [...rejectionReasons]
                                  reasons.splice(index, 1)
                                  setRejectionReasons(reasons)
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        fullWidth
                        sx={{
                          minWidth: '20rem'
                        }}
                        error={
                          formError.hasOwnProperty('rejectionReasons')
                            ? formError?.rejectionReasons[index]?.reason
                            : false
                        }
                        helperText={
                          formError.hasOwnProperty('rejectionReasons')
                            ? formError?.rejectionReasons[index]?.reason
                            : ''
                        }
                      />
                    </Grid>
                    <Divider
                      fullWidth
                      style={{
                        width: '100%',
                        marginTop: '16px'
                      }}
                    />
                    <Grid item xs={12}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={item.addToLibrary}
                              onChange={() => {
                                const reasons = [...rejectionReasons]
                                reasons[index].addToLibrary = !item.addToLibrary
                                setRejectionReasons(reasons)
                              }}
                            />
                          }
                          label='Also add to library'
                          style={{ color: theme.palette.text.secondary }}
                        />
                      </FormGroup>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: 'flex',
                      marginRight: '16px'
                    }}
                  >
                    <Grid item xs={0.8}>
                      <FormGroup>
                        <FormControlLabel
                          style={{
                            margin: '0px',
                            color: theme.palette.text.secondary
                          }}
                          key={index}
                          control={
                            <Checkbox
                              checked={item.isChecked}
                              onChange={event => {
                                const { checked } = event.target
                                const reasons = [...rejectionReasons]
                                reasons[index].isChecked = checked
                                setRejectionReasons(reasons)
                              }}
                            />
                          }
                        />
                      </FormGroup>
                    </Grid>
                    <Grid
                      item
                      xs={9}
                      style={{
                        display: 'flex',
                        justifyContent: 'left',
                        alignItems: 'center',
                        color: theme.palette.text.secondary
                      }}
                    >
                      {item.reason}
                    </Grid>
                    <Grid
                      item
                      xs={0.8}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer'
                      }}
                    >
                      <Button
                        style={{ textTransform: 'capitalize' }}
                        onClick={() => {
                          setEditRejection(item.reason)
                          setEditRejectionModal({ show: true, item, index })
                        }}
                      >
                        Edit
                      </Button>
                    </Grid>
                    <Divider
                      orientation='vertical'
                      variant='middle'
                      flexItem
                      style={{
                        margin: '7px 5px'
                      }}
                    />
                    <Grid
                      item
                      xs={0.8}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer'
                      }}
                    >
                      <Button
                        style={{ textTransform: 'capitalize' }}
                        onClick={() => {
                          setViewRejection(item)
                        }}
                      >
                        View
                      </Button>
                    </Grid>
                    <Divider
                      orientation='vertical'
                      variant='middle'
                      flexItem
                      style={{
                        margin: '7px 5px'
                      }}
                    />
                    <Grid
                      item
                      xs={0.8}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer'
                      }}
                    >
                      <Button
                        style={{ textTransform: 'capitalize' }}
                        onClick={() => {
                          const reasons = [...rejectionReasons]
                          reasons.splice(index, 1)
                          setRejectionReasons(reasons)
                        }}
                      >
                        Delete
                      </Button>
                    </Grid>
                  </Grid>
                )
              )}

              <Grid item xs={12} style={{ margin: '24px 0px' }}>
                <Button
                  variant='contained'
                  style={{
                    textTransform: 'none'
                  }}
                  onClick={() => {
                    setRejectionReasons(prev => [
                      ...prev,
                      {
                        reason: '',
                        isChecked: true,
                        isUserDefined: true,
                        addToLibrary: true
                      }
                    ])
                  }}
                >
                  Add a reject reason
                </Button>
              </Grid>

              <Grid
                item
                xs={6}
                style={{
                  display: 'flex',
                  fontWeight: 500,
                  flexDirection: 'column'
                }}
              >
                <div style={{ marginRight: '48px' }}>
                  <FormControl fullWidth>
                    <TextRegular
                      style={{
                        marginBottom: '6px',
                        color: theme.palette.text.secondary
                      }}
                    >
                      Reject button will expire in
                    </TextRegular>
                    <Select
                      required
                      id='rejectionPeriod'
                      value={rejectionPeriod}
                      onChange={e => setRejectionPeriod(e.target.value)}
                    >
                      <MenuItem required value={'1 business day'}>
                        1 business day
                      </MenuItem>
                      <MenuItem required value={'2 business day'}>
                        2 business day
                      </MenuItem>
                      <MenuItem required value={'3 business day'}>
                        3 business day
                      </MenuItem>
                      <MenuItem required value={'5 business day'}>
                        5 business day
                      </MenuItem>
                      <MenuItem required value={'7 business day'}>
                        7 business day
                      </MenuItem>
                      <MenuItem required value={'10 business day'}>
                        10 business day
                      </MenuItem>
                      <MenuItem required value={'Not applicable'}>
                        Not applicable
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Grid>

              <Dialog
                open={editRejectionModal?.show}
                onClose={() => closeEditModal()}
                fullWidth
              >
                <DialogTitle>Edit rejection reason</DialogTitle>
                <DialogContent>
                  <TextField
                    placeholder='Rejection reason'
                    value={editRejection}
                    onChange={e => {
                      setEditRejection(e.target.value)
                    }}
                    sx={{
                      width: '100%',
                      marginTop: '10px'
                    }}
                    size='small'
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    style={{ textTransform: 'capitalize' }}
                    variant='contained'
                    onClick={() => closeEditModal()}
                  >
                    Cancel
                  </Button>
                  <Button
                    disabled={isEmpty(editRejection)}
                    style={{ textTransform: 'capitalize' }}
                    variant='contained'
                    onClick={() => {
                      const reasons = [...rejectionReasons]
                      reasons[editRejectionModal.index].reason = editRejection
                      setRejectionReasons(reasons)
                      closeEditModal()
                    }}
                  >
                    Save
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={viewRejection !== null}
                onClose={() => setViewRejection(null)}
                fullWidth
              >
                <DialogTitle style={{ color: `${theme.palette.text.primary}` }}>
                  View rejection reason
                </DialogTitle>
                <DialogContent
                  style={{ color: `${theme.palette.text.primary}` }}
                >
                  {viewRejection?.reason}
                </DialogContent>
                <DialogActions>
                  <Button
                    style={{ textTransform: 'capitalize' }}
                    variant='contained'
                    onClick={() => setViewRejection(null)}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          )}
        </Grid>

        <Grid
          item
          xs={12}
          style={{ margin: '32px 0px 8px', paddingTop: '0px' }}
        >
          <Divider />
        </Grid>

        {/* <Grid item xs={6}>
              <FormControl fullWidth error={formError.educationLevel}>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  Education Level *
                </TextRegular>
                <Select
                  required
                  id='educationLevel'
                  value={educationLevel}
                  onChange={e => setEducationLevel(e.target.value)}
                >
                  {dropDownValues?.educationLevel?.map(item => (
                    <MenuItem required value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formError.educationLevel}</FormHelperText>
              </FormControl>
            </Grid> */}

        <Grid item xs={6}>
          <FormControl fullWidth error={formError.experienceLevel}>
            <TextRegular
              style={{
                color: theme.palette.text.secondary,
                marginBottom: '6px'
              }}
            >
              Experience Level *
            </TextRegular>
            <Select
              required
              id='experienceLevel'
              value={experienceLevel}
              onChange={e => setExperienceLevel(e.target.value)}
            >
              {dropDownValues?.experienceLevel?.map(item => (
                <MenuItem required value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{formError.experienceLevel}</FormHelperText>
          </FormControl>
        </Grid>
        {/* <Grid
              item
              xs={12}
              style={{ paddingLeft: '24px', marginBottom: '-42px' }}
            >
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                Required Experience *
              </TextRegular>
            </Grid> */}
        {/* <Grid item xs={3} style={{ display: 'flex', alignItems: 'end' }}>
              <FormControl fullWidth>
                <InputLabel id='Year'>Year *</InputLabel>
                <Select
                  required
                  id='Year'
                  label='Year'
                  value={requiredExpYear}
                  onChange={e => setRequiredExpYear(e.target.value)}
                >
                  {Array.from(Array(51).keys()).map(number => (
                    <MenuItem value={number}>{number}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} style={{ display: 'flex', alignItems: 'end' }}>
              <FormControl fullWidth>
                <InputLabel id='Months'>Months *</InputLabel>
                <Select
                  required
                  id='Months'
                  label='Months'
                  value={requiredExpMonth}
                  onChange={e => setRequiredExpMonth(e.target.value)}
                >
                  {Array.from(Array(12).keys()).map(number => (
                    <MenuItem value={number}>{number}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid> */}
        {/* Visa sponsorship eligibility 
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextRegular
                  style={{
                    color: theme.palette.text.secondary,
                    marginBottom: '6px'
                  }}
                >
                  Visa sponsorship eligibility *
                </TextRegular>
                <Select
                  required
                  id='visaSponsorship'
                  value={visaSponsorship}
                  onChange={e => setVisaSponsorship(e.target.value)}
                >
                  <MenuItem value={'yes'}>Yes</MenuItem>
                  <MenuItem value={'no'}>No</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}

        <Grid
          item
          xs={12}
          style={{ margin: '32px 0px 8px', paddingTop: '0px' }}
        >
          <Divider />
        </Grid>

        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            padding: '24px 0px 24px 24px'
          }}
        >
          <div style={{ width: '100%', margin: '0px' }}>
            <div
              maxWidth='lg'
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}
            >
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                Job Description *
              </TextRegular>
              <div>
                <FormControl fullWidth error={formError.jobDescription}>
                  <TextEditor
                    getter={jobDescription}
                    setter={setJobDescription}
                    placeholder={'Copy and paste the job description here.'}
                  />

                  <FormHelperText>{formError.jobDescription}</FormHelperText>
                </FormControl>
              </div>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px',
                  marginTop: '32px'
                }}
              >
                Skills *
              </TextRegular>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <FormControl fullWidth error={formError.skillRequired}>
                  <Box>
                    <TextField
                      placeholder='Press enter to enter multiple skills'
                      value={inputSkills}
                      onChange={event => {
                        const { value } = event.target
                        setInputSkills(value)
                        if (value) {
                          getSkillSuggestions(value)
                        }
                      }}
                      onKeyDownCapture={event => {
                        setPopperClick(true)
                        handleEnterSkills(event, event.target.value)
                      }}
                      InputProps={{
                        disableUnderline: true
                      }}
                      sx={{
                        width: '100%',
                        marginTop: '10px'
                      }}
                      ref={containerRef}
                      onFocus={() => {
                        setOpenPopper(true)
                        setPopperClick(true)
                      }}
                      onBlur={() => {
                        if (popperClick) {
                          setOpenPopper(true)
                        } else {
                          setOpenPopper(false)
                        }
                      }}
                    />
                    {skillRequired?.map((skill, index) => (
                      <Chip
                        key={index}
                        label={skill}
                        onDelete={() => handleDeleteSkill(index)}
                        style={{
                          margin: '2px'
                        }}
                        sx={{
                          '& .MuiChip-deleteIcon': {
                            color: `${theme.palette.primary.main}`
                          }
                        }}
                      />
                    ))}

                    <Popper
                      open={
                        skillSuggestions.length > 0 && openPopper && popperClick
                      }
                      anchorEl={containerRef.current}
                      placement='bottom-start'
                    >
                      <ClickAwayListener
                        onClickAway={event => {
                          if (!containerRef.current.contains(event.target)) {
                            setPopperClick(false)
                            setOpenPopper(false)
                          }
                        }}
                      >
                        <Paper
                          sx={{
                            padding: '0px',
                            width: containerRef?.current?.clientWidth
                          }}
                        >
                          <Grid container>
                            <Grid item xs={12}>
                              <ul
                                style={{
                                  listStyleType: 'none',
                                  padding: '0px',
                                  margin: '0px'
                                }}
                              >
                                {skillSuggestions.map((skill, index) => (
                                  <>
                                    <Button
                                      style={{
                                        color: theme.palette.text.secondary,
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'left',
                                        textTransform: 'none'
                                      }}
                                      onClick={event => {
                                        handleEnterSkills(
                                          event,
                                          skill.skill_name
                                        )
                                      }}
                                    >
                                      <li
                                        key={index}
                                        style={{
                                          padding: '10px',
                                          lineHeight: '1rem'
                                        }}
                                      >
                                        {skill.skill_name}
                                      </li>
                                    </Button>
                                    {index < skillSuggestions.length - 1 && (
                                      <Divider style={{ width: '100%' }} />
                                    )}
                                  </>
                                ))}
                              </ul>
                            </Grid>
                          </Grid>
                        </Paper>
                      </ClickAwayListener>
                    </Popper>
                  </Box>
                  <FormHelperText>{formError.skillRequired}</FormHelperText>
                </FormControl>
              </div>
            </div>
          </div>
        </div>

        {/* <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                justifyContent: 'left',
                paddingLeft: '24px',
                marginBottom: '24px'
              }}
            >
              <TextBold style={{ fontSize: '18px', lineHeight: '24px' }}>
                Pre-screen questionnaire
              </TextBold>
            </Grid> */}

        {/* {preScreenQuesJobType?.map((item, index) => (
              <Grid
                container
                style={{
                  display: 'flex',
                  margin: '12px 0px 24px 24px'
                }}
              >
                <Grid
                  key={index}
                  item
                  xs={12}
                  style={{
                    display: 'flex',
                    flexGrow: 1
                  }}
                >
                  <Grid
                    item
                    xs={6}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column'
                    }}
                  >
                    <div style={{ fontWeight: 500 }}>Question</div>

                    <TextField
                      key={index}
                      size='small'
                      placeholder={'Please enter a question'}
                      value={item.question}
                      onChange={e => {
                        const { value } = e.target
                        const questions = [...preScreenQuesJobType]
                        questions[index].question = value
                        setPreScreenQuesJobType(questions)
                      }}
                      sx={{
                        width: '100%',
                        marginTop: '10px'
                      }}
                      error={
                        formError.hasOwnProperty('preScreenQuesJobType')
                          ? formError?.preScreenQuesJobType[index]?.question
                          : false
                      }
                      helperText={
                        formError.hasOwnProperty('preScreenQuesJobType')
                          ? formError?.preScreenQuesJobType[index]?.question
                          : ''
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      marginLeft: '10px'
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 500,
                        marginBottom: '10px'
                      }}
                    >
                      Answer type
                    </div>
                    {item.isUserDefined ? (
                      <FormControl fullWidth>
                        <Select
                          required
                          id='anstype'
                          value={item.type}
                          onChange={e => {
                            var value = e.target.value
                            const questions = [...preScreenQuesJobType]
                            questions[index].type = value
                            if (value !== 'textfield') {
                              questions[index].options = [
                                { name: '', isQualify: true },
                                { name: '', isQualify: true }
                              ]
                            } else {
                              questions[index].options = []
                            }
                            setPreScreenQuesJobType(questions)
                          }}
                          size='small'
                          fullWidth
                        >
                          <MenuItem value={'textfield'}>Text Field</MenuItem>
                          <MenuItem value={'checkbox'}>Checkbox</MenuItem>
                          <MenuItem value={'dropdown'}>Drop Down</MenuItem>
                          <MenuItem value={'radio'}>Radio Button</MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      <div style={{ textTransform: 'capitalize' }}>
                        {item.type}
                      </div>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-evenly',
                      alignItems: 'center'
                    }}
                  >
                    <Tooltip title='Delete'>
                      <IconButton
                        onClick={() => {
                          if (item.employerId) {
                            setModal({
                              open: true,
                              message:
                                'Do you want to delete this question from library also?',
                              onClose: () => {
                                setModal({ open: false })
                              },
                              positiveBtnText: 'Yes',
                              onClickPositiveButton: () => {
                                setModal({ open: false })
                                deleteQuestionFromLibrary(item, index)
                              },
                              negativeBtnText: 'No, only delete for now',
                              onClickNegativeButton: () => {
                                setModal({ open: false })
                                const questions = [...preScreenQuesJobType]
                                questions.splice(index, 1)
                                setPreScreenQuesJobType(questions)
                              }
                            })
                          } else {
                            const questions = [...preScreenQuesJobType]
                            questions.splice(index, 1)
                            setPreScreenQuesJobType(questions)
                          }
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                    {index > 0 ? (
                      <IconButton
                        onClick={() => {
                          const questions = [...preScreenQuesJobType]
                          questions[index] = questions[index - 1]
                          questions[index - 1] = item
                          setFormError({})
                          setPreScreenQuesJobType(questions)
                        }}
                      >
                        <ArrowUpwardIcon />
                      </IconButton>
                    ) : null}
                  </Grid>
                </Grid>

                {item.options.length > 0 && (
                  <Grid item xs={12}>
                    <Grid xs={12} container sx={{ mt: 2 }}>
                      <Grid xs={4} item>
                        <div>Answer Choices</div>
                      </Grid>
                      <Grid xs={2} item>
                        <IconButton
                          onClick={() => {
                            const questions = [...preScreenQuesJobType]

                            questions[index].options.push({
                              name: '',
                              isQualify: true
                            })

                            setPreScreenQuesJobType(questions)
                          }}
                          sx={{ ml: 2, fontSize: 14 }}
                        >
                          <AddIcon /> Add choice
                        </IconButton>
                      </Grid>
                    </Grid>

                    {item?.options?.map((option, optionIndex) => (
                      <Grid item xs={12} container sx={{ mt: 2 }}>
                        <Grid item xs={4}>
                          <TextField
                            label={`Option ${optionIndex + 1}`}
                            variant='outlined'
                            value={option.name}
                            onChange={e => {
                              const questions = [...preScreenQuesJobType]
                              questions[index].options[optionIndex].name =
                                e.target.value
                              setPreScreenQuesJobType(questions)
                            }}
                            fullWidth
                            sx={{
                              width: '100%'
                            }}
                            size='small'
                            error={
                              formError.hasOwnProperty(
                                'preScreenQuesJobType'
                              ) &&
                              formError?.preScreenQuesJobType.hasOwnProperty(
                                index
                              ) &&
                              formError.preScreenQuesJobType[
                                index
                              ].hasOwnProperty('options')
                                ? formError?.preScreenQuesJobType[index]
                                    ?.options[optionIndex]
                                : false
                            }
                            helperText={
                              formError.hasOwnProperty(
                                'preScreenQuesJobType'
                              ) &&
                              formError?.preScreenQuesJobType.hasOwnProperty(
                                index
                              ) &&
                              formError.preScreenQuesJobType[
                                index
                              ].hasOwnProperty('options')
                                ? formError?.preScreenQuesJobType[index]
                                    ?.options[optionIndex]
                                : ''
                            }
                          />
                        </Grid>
                        <Grid item xs={2} sx={{ ml: 1 }}>
                          <Select
                            required
                            id='anstype'
                            value={option.isQualify}
                            onChange={e => {
                              const questions = [...preScreenQuesJobType]
                              questions[index].options[optionIndex].isQualify =
                                e.target.value
                              setPreScreenQuesJobType(questions)
                            }}
                            size='small'
                            fullWidth
                          >
                            <MenuItem value={true}>Qualify</MenuItem>
                            <MenuItem value={false}>Disqualify</MenuItem>
                          </Select>
                        </Grid>
                        {optionIndex > 1 && (
                          <IconButton
                            onClick={() => {
                              const questions = [...preScreenQuesJobType]
                              questions[index].options.splice(optionIndex, 1)

                              setPreScreenQuesJobType(questions)
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </Grid>
                    ))}
                  </Grid>
                )}

                {item.isUserDefined && (
                  <>
                    <Grid item xs={4}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={item.addToLibrary}
                              onChange={() => {
                                const questions = [...preScreenQuesJobType]
                                questions[index].addToLibrary =
                                  !item.addToLibrary
                                setPreScreenQuesJobType(questions)
                              }}
                            />
                          }
                          label='Also add to question library'
                        />
                      </FormGroup>
                    </Grid>

                    <Grid item xs={4}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={item.isRequired}
                              onChange={() => {
                                const questions = [...preScreenQuesJobType]
                                questions[index].isRequired = !item.isRequired
                                setPreScreenQuesJobType(questions)
                              }}
                            />
                          }
                          label='Required to be answered*'
                        />
                      </FormGroup>
                    </Grid>
                  </>
                )}
                <Divider
                  fullWidth
                  style={{
                    width: '100%',

                    marginTop: '24px'
                  }}
                />
              </Grid>
            ))} */}

        {/* <Grid item xs={12}>
              <Button
                variant='contained'
                style={{ textTransform: 'none' }}
                onClick={() => {
                  setPreScreenQuesJobType(prev => [
                    ...prev,
                    {
                      question: '',
                      type: 'textfield',
                      options: [],
                      isRequired: true,
                      isUserDefined: true,
                      addToLibrary: true
                    }
                  ])
                }}
              >
                Add another question
              </Button>
            </Grid> */}

        {/* Assign job to a team member: */}

        {/* Job email send*/}
        <Grid item xs={12} style={{ display: 'none' }}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={emailShow}
                  onChange={() => setEmailShow(!emailShow)}
                />
              }
              style={{ color: theme.palette.text.secondary }}
              label='Send email notifications to different email.'
            />
          </FormGroup>
        </Grid>

        {emailShow === true && (
          <Grid item xs={6} style={{ display: 'flex', margin: '0px 1px' }}>
            <FormControl fullWidth error={formError.emailCc}>
              <Box
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  padding: '5px',
                  border: `1px solid ${theme.palette.border.main}`,
                  borderRadius: '5px',
                  width: '100%'
                }}
              >
                {emailCc?.map((email, index) => (
                  <Chip
                    key={index}
                    label={email}
                    onDelete={() => {
                      var emails = [...emailCc]
                      emails.splice(index, 1)
                      setEmailCc(emails)
                    }}
                    style={{
                      margin: '2px'
                    }}
                    sx={{
                      '& .MuiChip-deleteIcon': {
                        color: theme.palette.primary.main
                      }
                    }}
                  />
                ))}

                <TextField
                  placeholder='Press enter to add multiple emails'
                  value={inputEmail}
                  onChange={e => setInputEmail(e.target.value)}
                  onKeyDownCapture={event => {
                    const email = inputEmail.trim()
                    if (event.key === 'Enter' && !isEmpty(email)) {
                      if (validateEmail(email)) {
                        if (emailCc.includes(email)) {
                          showToast('Email already added')
                        } else {
                          setEmailCc([...emailCc, email])
                          setInputEmail('')
                        }
                      } else {
                        showToast('Please enter a valid email address')
                      }
                    }
                  }}
                  InputProps={{
                    disableUnderline: true
                  }}
                  sx={{
                    width: '100%',
                    marginTop: '10px'
                  }}
                />
                <FormHelperText>{formError.emailCc}</FormHelperText>
              </Box>
            </FormControl>
          </Grid>
        )}

        {/* <Grid item xs={6}>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  marginBottom: '6px'
                }}
              >
                Your organization's job order number *
              </TextRegular>
              <TextField
                variant='outlined'
                value={jobOrderNumber}
                onChange={e => {
                  setJobOrderNumber(e.target.value)
                }}
                fullWidth
                sx={{
                  width: '100%'
                }}
              />
            </Grid> */}

        <Grid
          item
          xs={12}
          style={{ margin: '32px 0px 8px 0px', paddingTop: '0px' }}
        >
          <Divider />
        </Grid>

        {/* Buttons*/}
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row', padding: '0px' }}
        >
          {!data?.isEdit ? (
            <div style={{ paddingLeft: '16px', display: 'flex' }}>
              <Grid style={{ margin: '10px' }}>
                <AppButton
                  variant='contained'
                  name={'Save as draft'}
                  style={{ width: 'fit-content' }}
                  disabled={false}
                  loading={jobDraftLoading}
                  onClick={() => handleSubmitJob(true)}
                />
              </Grid>

              <Grid style={{ margin: '10px' }}>
                <AppButton
                  variant='contained'
                  name={'Save and post'}
                  style={{ width: 'fit-content' }}
                  disabled={false}
                  loading={jobPostLoading}
                  onClick={() => handleSubmitJob(false)}
                />
              </Grid>
            </div>
          ) : (
            <>
              <Grid style={{ margin: '10px' }}>
                <AppButton
                  variant='contained'
                  name={'Update'}
                  disabled={false}
                  loading={jobUpdateLoading}
                  onClick={() => handleSubmitJob()}
                />
              </Grid>
              <Grid style={{ margin: '10px' }}>
                <Button
                  variant='contained'
                  style={{ textTransform: 'none' }}
                  onClick={() => {
                    navigate('/employer/managejob')
                  }}
                >
                  Go Back
                </Button>
              </Grid>
            </>
          )}

          <Grid style={{ margin: '10px' }}>
            <Button
              variant='contained'
              style={{ textTransform: 'none' }}
              onClick={() => {
                if (validateForm()) {
                  setPreviewModal({
                    open: true,
                    company: user.companyname,
                    jobDescription: jobDescription,
                    title: jobTitle,
                    type: dropDownValues?.jobTypes?.find(e => e.id === jobType)
                      ?.name,
                    jobFunction: dropDownValues?.jobFunctions?.find(
                      e => e.id === jobFunction
                    )?.name,

                    experienceLevel: dropDownValues?.experienceLevel?.find(
                      e => e.id === experienceLevel
                    )?.name,
                    // education: dropDownValues?.educationLevel?.find(
                    //   e => e.id === educationLevel
                    // )?.name,
                    compensationFrom: jobCompensationAmountMin,
                    compensationTo: jobCompensationAmountMax,
                    // state: state,
                    // country: country,
                    // zipCode: zipCode,
                    skill: skillRequired.join(', '),
                    experienceYears: requiredExpYear,
                    experienceMonths: requiredExpMonth,
                    onClose: () => {
                      setPreviewModal({
                        open: false
                      })
                    }
                  })
                }
              }}
            >
              Preview
            </Button>
          </Grid>
          <Grid style={{ margin: '10px' }}>
            <Button
              variant='outlined'
              style={{ textTransform: 'none' }}
              onClick={() => {
                navigate('/employer/managejob')
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Grid>
      {modal.open && <CustomModal data={modal} />}
      {previewModal.open && <JobPostPreviewModal data={previewModal} />}
    </Grid>
  )
}
